export const productos: any = [
  {
    name: "Abono fertilizante",
    categorias: ["Tratamientos de agua y acueductos", "Petróleo"],//nueva categoria
    slug: "abono-fertilizante",
    portada: "/images/productos.webp",
    descripcion:
      "Los abonos son fertilizantes que pueden ser de tipo edáfico y puede haber mezclas compuestas por gránulos de Urea, Fosfato Mono amónico, Nitrógeno, Sulfato de Potasio, Magnesio, fosforo, potasio y algunos otros compuestos, se encuentran en sacos de 50 Kilos.",
    usos: "Los abonos son formulados para suplir necesidades nutricionales en cultivos de pastos y praderas, empleado en hortalizas y otros diversas cultivares.",
    composicion: [
      { name: "Nitrógeno Total (N)", valor: "31.0%" },
      { name: "Nitrógeno Amoniacal (N)", valor: "1.5%" },
      { name: "Nitrógeno Uréico N", valor: "29.5%" },
      { name: "Fósforo Asimilable (P2O5)", valor: "8.0%" },
      { name: "Potasio Soluble en Agua (K2O)", valor: "8.0%" },
      { name: "Calcio Total (CaO)", valor: "15.0%" },
      { name: "Hierro Total (Fe)", valor: "0.5%" },
      { name: "Manganeso Total (Mn)", valor: "0.1%" },
      { name: "Cobre Total (Cu)", valor: "0.2%" },
      { name: "Zinc Total (Zn)", valor: "0.3%" },
    ],
  },
  {
    name: "Aceite Mineral",
    categorias: ["Alimentos", "Farmacéutico", "Limpieza"],
    slug: "aceite-mineral",
    portada: "/images/productos.webp",
    descripcion:
      "El aceite mineral es transparente, incoloro, insoluble en agua y alcohol.",
    usos: "El aceite mineral es muy utilizado en la lubricación de las máquinas, en especial de los motores. Es utilizado en distintas industrias: automotriz, cosmética, farmacéutica y metal mecánica.",
    composicion: [
      { name: "Gravedad Específica a 25°C", valor: "0.818-0.880" },
      { name: "Viscosidad (40°C)", valor: "3.0-34.4 Mm2/s" },
      {
        name: "Acidez",
        valor:
          "Menos de 1ml de hidróxido de sodio 0.01N, fue requerido para el cambio de color",
      },
    ],
  },
  {
    name: "Ácido Acético Grado Alimenticio",
    categorias: ["Farmacéutico", "Alimentos", "Curtiembres"],

    slug: "acido-acetico-grado-alimenticio",
    portada: "/images/productos.webp",
    descripcion:
      "El ácido acético grado alimenticio es un antiséptico de amplio espectro, compuesto puro (99,8% mínimo food grade), y se diferencia de las soluciones acuosas frecuentemente halladas.",
    usos: "El ácido acético grado alimenticio sirve como regulador de acidez, conservante, regulador de pH, aditivo de alimentos y en medicina se aplica como tinte en colposcopias, entre otras funciones.",
    composicion: [
      { name: "Pureza", valor: "99% Min" },
      { name: "Cloruro", valor: "1% máx." },
      { name: "Sulfato", valor: "1% máx." },
      { name: "Hierro", valor: "0.5 máx." },
      { name: "Metales pesados", valor: "0.5 máx." },
      { name: "Agua", valor: "0.15 máx." },
    ],
  },
  {
    name: "Ácido acético",
    categorias: ["Tratamientos de agua y acueductos", "Farmacéutico", "Alimentos", "Agroquímicos", "Petróleo"],

    slug: "acido-acetico",
    portada: "/images/productos.webp",
    descripcion:
      "El ácido acético es un líquido incoloro con olor penetrante y picante. La sustancia es moderadamente ácida, volátil y cristaliza a baja temperatura. Es completamente soluble en agua, alcohol, éter glicerina y benceno; e insoluble en sulfuro de carbono.",
    usos: "El ácido acético es un producto utilizado para la fabricación de plásticos y caucho, en ésteres acéticos, productos farmacéuticos, colorantes, insecticidas, coagulante de látex natural, acidificador de pozos de petróleo y en algunas industrias para el tratamiento de agua.",
    composicion: [
      { name: "Color (unidades apha)", valor: "30 máx." },
      { name: "Gravedad especifica", valor: "1.0490 – 1.0560" },
      { name: "Humedad", valor: "0.50 % máx." },
      { name: "Olor", valor: "característico" },
      { name: "Pureza", valor: "99 % min." },
      { name: "Agua", valor: "99 % min." },
    ],
  },
  {
    name: "Ácido Ascórbico",
    categorias: ["Alimentos"],

    slug: "acido-ascorbico",
    portada: "/images/productos.webp",
    descripcion:
      "El ácido ascórbico es un polvo blanco cristalino de olor ligero y característico, sólido soluble en agua, actúa como antioxidante y/o vitamina C.",
    usos: "El ácido ascórbico es utilizado principalmente en la producción de diversos medicamentos como material de importancia clínica para la práctica complementaria de curación en diferentes sectores. Actúa como antioxidante en alimentos y bebidas.",
    composicion: [
      { name: "Pureza", valor: "99-100%" },
      { name: "Acidez (pH)", valor: "2,1-2,6" },
      { name: "Acidez (pH solución acuosa)", valor: "2,4-2,8" },
      { name: "Metales pesados", valor: "≤10 ppm" },
      { name: "Cobre", valor: "≤5 ppm" },
    ],
  },
  {
    name: "Ácido Bórico",
    categorias: ["Tratamientos de agua y acueductos", "Alimentos", "Limpieza", "Petróleo"], // Se ajustan múltiples categorías
    slug: "acido-borico",
    portada: "/images/productos.webp",
    descripcion:
      "El ácido bórico es un producto estable en el aire, soluble en agua, alcohol y glicerina. Es un ácido débil.",
    usos: "El ácido bórico es utilizado principalmente en la industria del vidrio, esmaltes, frutas, fruticultura, cosmética y farmacia, refrigeración de metales no ferrosos, curtiembres, industria textil, ignífugos y pinturas.",
    composicion: [
      { name: "Peso molecular", valor: "61,84" },
      { name: "Punto de fusión", valor: "170ºC" },
      { name: "Densidad relativa", valor: "1,435 a 15ºC" },
      { name: "Calor de disolución", valor: "5400 cal/mol a 18ºC" },
      { name: "pH de soluciones", valor: "a 20ºC" },
    ],
  },
  {
    name: "Ácido Cítrico",
    categorias: ["Tratamientos de agua y acueductos", "Alimentos", "Agroquímicos", "Petróleo", "Limpieza"], // Se ajustan múltiples categorías
    slug: "acido-citrico",
    portada: "/images/productos.webp",
    descripcion:
      "El ácido cítrico se presenta como cristales translúcidos o como un polvo blanco, con tamaños de partícula que varían desde el extra granular hasta el extra fino.",
    usos: "El ácido cítrico es un excelente conservante y antioxidante natural que se añade industrialmente como aditivo en el envasado de muchos alimentos como las conservas vegetales enlatadas.",
    composicion: [
      { name: "Assay (%)", valor: "99.5 – 100.5" },
      { name: "Water (%)", valor: "<0.5 (0.12%)" },
      { name: "Readily Carbonisable", valor: "Pass test" },
      { name: "Sulfated Ash (%)", valor: "<0.05 (0.02%)" },
      { name: "Sulfate (Mg/kg)", valor: "<50" },
      { name: "Oxalate (Mg/kg)", valor: "<50" },
      { name: "Chloride (Mg/kg)", valor: "<5" },
    ],
  },
  {
    name: "Ácido Crómico",
    categorias: ["Petróleo", "Curtiembres", "Limpieza", "Farmacéutico", "Agroquímicos"], // Se ajustan múltiples categorías
    slug: "acido-cromico",
    portada: "/images/productos.webp",
    descripcion:
      "El ácido crómico es un agente fuerte y un oxidante empleado usualmente en el cromado de objetos por electrolisis.",
    usos: "Los principales usos del ácido crómico son la conservación de madera, el acabado del metal, la galvanoplastia y aplicaciones secundarias que incluyen la fabricación de catalizador y cintas de grabación magnética.",
    composicion: [
      { name: "Pureza", valor: "99.85%" },
      { name: "Sulfato", valor: "0.1% máx" },
      { name: "Cloruros", valor: "0.005% máx" },
      { name: "Materia insoluble", valor: "0.005% máx" },
      { name: "Sodio", valor: "0.020% máx" },
    ],
  },
  {
    name: "Ácido Fórmico",
    categorias: ["Tratamientos de agua y acueductos", "Farmacéutico", "Limpieza", "Petróleo", "Curtiembres"], // Se ajustan múltiples categorías
    slug: "acido-formico",
    portada: "/images/productos.webp",
    descripcion:
      "El ácido fórmico es un ácido orgánico de un solo átomo de carbono, siendo el más simple de los ácidos orgánicos. Es un líquido incoloro con un olor fuerte y penetrante, y su sabor es fuertemente ácido.",
    usos: "El ácido fórmico es neutralizante para soluciones alcalinas, facilita la aplicación de resinas en la etapa de acabados, es un excelente desinfectante en tejidos, y puede sustituir eventualmente al ácido sulfúrico. Se emplea en industrias como insecticidas, fumigantes, minas, perfumes, y pinturas, entre otros.",
    composicion: [
      { name: "Peso molecular", valor: "46 g/mol" },
      { name: "Concentración", valor: "70% +/-2" },
      { name: "Color APHA", valor: "1" },
      { name: "Solubilidad", valor: "En agua, alcohol y éter" },
      { name: "Densidad 20ºC", valor: "1.22 g/cc" },
    ],
  },
  {
    name: "Ácido Fosfórico",
    categorias: ["Alimentos", "Tratamientos de agua y acueductos", "Petróleo", "Limpieza", "Agroquímicos"], // Solo una categoría asignada
    slug: "acido-fosforico",
    portada: "/images/acido-fosforico.webp",
    descripcion:
      "El ácido fosfórico es un líquido brillante, incoloro e inodoro o sólido cristalino transparente, dependiendo de la concentración y la temperatura. A temperatura de 20°C, el ácido fosfórico de concentraciones 50 y 75% es líquido móvil, al 85% es de consistencia siruposa y al 100% se presenta en forma de cristales.",
    usos: "El ácido fosfórico se utiliza como regulador de la acidez y como agente secuestrante (forma complejos con los iones metálicos). También en otras funciones específicas se puede mencionar que aumenta la permeabilidad de la sal en las carnes y actúa como antioxidante.",
    composicion: [
      { name: "Apariencia", valor: "Líquido incoloro" },
      { name: "Olor", valor: "Inodoro" },
      { name: "pH", valor: "< 0.5 (solución al 100 g/L H2O, 20°C)" },
      { name: "Punto de fusión", valor: "21 °C min" },
      { name: "Punto de ebullición", valor: "158°C" },
    ],
  },
  {
    name: "Ácido Nítrico",
    categorias: ["Tratamientos de agua y acueductos", "Limpieza", "Petróleo", "Agroquímicos", "Farmacéutico"], // Solo una categoría asignada
    slug: "acido-nitrico",
    portada: "/images/acido-nitrico.webp",
    descripcion:
      "El ácido nítrico se obtiene haciendo reaccionar amoniaco gaseoso y aire a una presión de 2.5 Kg/cm² en un reactor especial a través de un catalizador de Platino y Rodio. Es un producto de fabricación sintética mediante la oxidación del Amoniaco.",
    usos: "El ácido nítrico se encuentra en la industria de los fertilizantes, en la elaboración de explosivos y en la industria de la química orgánica (barnices, pigmentos, nitrocelulosas, algodón hidrófilo, nitratos y otros usos). Es usado en la obtención de nitratos, tanto en el campo inorgánico como en el orgánico, así como en derivados Nitro en todas las ramas de la química orgánica.",
    composicion: [
      { name: "Concentración", valor: "55.0% w/w" },
      { name: "Densidad", valor: "1.333 g/cm³ @ 25°C" },
      { name: "Sulfatos", valor: "50.0 ppm Max" },
      { name: "Cloruros", valor: "30.0 ppm Max" },
      { name: "Hierro", valor: "1.0 ppm Max" },
    ],
  },
  {
    name: "Ácido Oxálico",
    categorias: ["Alimentos", "Tratamientos de agua y acueductos", "Limpieza", "Petróleo", "Farmacéutico"],
    slug: "acido-oxalico",
    portada: "/images/acido-oxalico.webp",
    descripcion:
      "El ácido oxálico es el primero de la serie de los ácidos dicarboxílicos. En su forma comercial viene dihidratado (2 moléculas de agua). A temperatura ambiente se presenta en forma de cristales prismáticos monocíclicos, transparentes y viene en sacos de 25 kilos.",
    usos: "El ácido oxálico es muy efectivo para remover y precipitar el calcio y para quelatar el hierro y otros cationes metálicos. Tiene un poder reductor y su fortaleza ácida, unidos a las ventajas de ser un ácido orgánico, lo hacen particularmente atractivo para ciertas industrias: la industria de la construcción, el aseo del hogar, la industria del cuero, la industria textil, el lavado de la ropa y la industria metalmecánica.",
    composicion: [
      { name: "Pureza (HCOOH)", valor: "99.6% Mín." },
      { name: "Sulfatos", valor: "0.08% Máx." },
      { name: "Metales pesados", valor: "0.001% Máx." },
      { name: "Hierro (Fe)", valor: "0.0015% Máx." },
      { name: "Cloruros (como Cl)", valor: "0.002% Máx." },
    ],
  },
  {
    name: "Ácido Sulfónico",
    categorias: ["Limpieza", "Agroquímicos", "Petróleo", "Curtiembres"],
    slug: "acido-sulfonico",
    portada: "/images/acido-sulfonico.webp",
    descripcion:
      "El ácido sulfónico es un surfactante sintético aniónico derivado principalmente del petróleo. Está conformado por una mezcla con diferentes longitudes de cadena de carbonos desde C10-C14, las cuales ofrecen diferentes propiedades tanto físicas como químicas, lo que permite diversas aplicaciones. Se considera un producto amigable con el medio ambiente por su alta biodegradabilidad.",
    usos: "El ácido sulfónico ayuda a reducir la tensión superficial entre líquidos, en la producción de detergentes en polvo tanto industriales como para cuidado de prendas y hogar, jabones líquidos, jabones lava loza y otros tipos de limpiadores para el hogar. También se usa como emulsificante en herbicidas agrícolas y emulsiones de polimerización.",
    composicion: [
      { name: "Materia activa", valor: "% (mín) 96" },
      { name: "Valor ácido", valor: "mg KOH/g 175 – 185" },
      { name: "Ácido sulfúrico libre", valor: "% H2SO4 (máx) 2" },
      { name: "Aceite libre", valor: "% (máx) 2" },
      { name: "Color Klett", valor: "(5% en solución) (máx) 7" },
    ],
  },
  {
    name: "Agua Desmineralizada",
    categorias: ["Tratamientos de agua y acueductos", "Alimentos", "Limpieza", "Farmacéutico"],
    slug: "agua-desmineralizada",
    portada: "/images/agua-desmineralizada.webp",
    descripcion:
      "El agua desmineralizada es un agua libre de minerales disueltos, lo que provoca una baja conductividad eléctrica.",
    usos: "El agua desmineralizada se utiliza en laboratorios para el enjuague de material de vidrio, equipos eléctricos, hacer diluciones de productos químicos (cosméticos y farmacéuticos), en análisis volumétricos sencillos y como material para equipos de calentamiento que deben ser refrigerados, como hornos y estufas de laboratorios.",
    composicion: [
      { name: "Sólidos totales disueltos", valor: "< 7.50 mg/L" },
      { name: "pH a 25°C", valor: "5.3 - 7.8" },
      { name: "Dureza total (mg/l CaCO3)", valor: "< 7.5 ppm CaCO3" },
      { name: "Densidad", valor: "1.00 mg/L" },
      { name: "Conductividad", valor: "0.1 - 5.0 µS/cm a 24°C" },
    ],
  },
  {
    name: "Agua Destilada",
    categorias: ["Tratamientos de agua y acueductos", "Alimentos", "Limpieza", "Farmacéutico"],
    slug: "agua-destilada",
    portada: "/images/agua-destilada.webp",
    descripcion:
      "El agua destilada está compuesta por dos átomos de Hidrógeno y uno de Oxígeno, y es sometida a un proceso de destilación donde se eliminan impurezas.",
    usos: "El agua destilada se usa en sistemas de análisis microbiológico, procesos hospitalarios, farmacéuticos, preparación de cosméticos, sistemas de funcionamiento láser, autoclaves, lavado y preparación de alimentos. También se utiliza en el lavado y limpieza de cristales, agricultura y cultivos de flores, esterilizadores, vaporizadores, inhaladores, humidificadores, entre otros.",
    composicion: [
      { name: "Sólidos totales disueltos", valor: "< 7.50 mg/L" },
      { name: "pH a 25°C", valor: "5.5 - 7.7" },
      { name: "Dureza total (mg/l CaCO3)", valor: "< 7.5 ppm CaCO3" },
      { name: "Densidad", valor: "1.00 mg/L" },
      { name: "Conductividad", valor: "0.1 - 5.0 µS/cm a 24°C" },
    ],
  },
  {
    name: "Alcohol Etílico 96%",
    categorias: ["Limpieza", "Farmacéutico", "Alimentos", "Agroquímicos", ],
    slug: "alcohol-etilico-96",
    portada: "/images/alcohol-etilico-96.webp",
    descripcion:
      "El alcohol etílico 96% es un compuesto químico, líquido incoloro e inflamable con un punto de ebullición de 78°C.",
    usos: "El alcohol etílico sirve como disolvente para resinas, grasas, aceites, ácidos grasos, hidrocarburos, hidróxidos alcalinos, como medio de extracción por solventes en la fabricación de intermedios, derivados orgánicos, colorantes, drogas sintéticas. También se usa en aplicaciones de elastómeros, detergentes, soluciones para limpieza, revestimientos cosméticos, anticongelante, antisépticos, medicina. Es un producto con una gran cantidad de aplicaciones en la industria y en el hogar.",
    composicion: [
      { name: "Color", valor: "Incoloro" },
      { name: "Grado alcohólico ºGL", valor: "Mínimo 96%" },
      { name: "Barbet (minutos)", valor: "Mínimo 30.0" },
      { name: "Acidez acética (ppm)", valor: "Mínimo 10.0" },
      { name: "Ésteres (ppm)", valor: "Mínimo 25.0" },
    ],
  },
  {
    name: "Alumbre",
    categorias: ["Tratamientos de agua y acueductos", "Alimentos", "Piscinas recreativas", "Farmacéutico", "Limpieza"],
    slug: "alumbre",
    portada: "/images/alumbre.webp",
    descripcion:
      "El alumbre son cristales incoloros o ligeramente amarillos, inoloros de sabor fuertemente astringente, soluble en agua y glicerina, insoluble en alcohol.",
    usos: "El alumbre es usado principalmente en la agroindustria, especialmente en la del banano para el lavado del látex, también se usa en el mantenimiento de piscinas, tratamiento de aguas, como mordiente en la industria del cuero y textilería, encolado y blanqueado del papel, como agente y clarificante.",
    composicion: [
      { name: "Contenido de aluminio como Al2O3 (%)", valor: "11.14 (min)" },
      { name: "Contenido de hierro como Fe2O3 (ppm)", valor: "100 máximo" },
      {
        name: "Contenido de material insoluble en agua (%)",
        valor: "0.20 máximo",
      },
      { name: "pH en solución al 1%", valor: "2.9 - 3.5" },
    ],
  },
  {
    name: "Amonio Cuaternario No Orgánico",
    categorias: ["Limpieza", "Farmacéutico", "Alimentos"], // Agregado a categorías de limpieza y farmacéutica
    slug: "amonio-cuaternario-no-organico",
    portada: "/images/amonio-cuaternario-no-organico.webp",
    descripcion:
      "El amonio cuaternario no orgánico es un compuesto por alcohol etílico (20%), compuesto a base de amonio cuaternario de quinta generación (4%), desinfectante a base de tomillo (10%), agua des-ionizada (66 %).",
    usos: "El amonio cuaternario no orgánico es utilizado como desinfectante industrial orgánico de amplio espectro. Biocida, bactericida, fungicida, esporicida y virucida. Biodegradable, es usado en la desinfección de superficies metálicas, plásticos, PVC, caucho, concreto, cerámica, vidrio, paredes, techos.",
    composicion: [
      { name: "Estado físico", valor: "Líquido" },
      { name: "Color", valor: "Blanco" },
      { name: "Olor", valor: "Tomillo" },
      { name: "pH", valor: "7.5 – 7.9" },
      { name: "Densidad", valor: "0.96 – 1.00 g/ml" },
    ],
  },
  {
    name: "Amonio Cuaternario Orgánico",
    categorias: ["Limpieza", "Farmacéutico", "Alimentos"], // Agregado a categorías de limpieza y farmacéutica
    slug: "amonio-cuaternario-organico",
    portada: "/images/amonio-cuaternario-organico.webp",
    descripcion:
      "El amonio cuaternario orgánico es un compuesto por alcohol etílico (2%), compuesto a base de amonio cuaternario de quinta generación (0.1%), desinfectante a base de tomillo (1%), agua des-ionizada (96.9%).",
    usos: "El amonio cuaternario orgánico se utiliza para la desinfección de superficies metálicas, plásticos, PVC, caucho, concreto, cerámica, vidrio, paredes, techos, para desinfección en la piel (tener en cuenta que si presenta irritación suspender el uso del producto inmediatamente). El amonio cuaternario orgánico también es usado como desinfectante industrial orgánico de amplio espectro. Biocida, bactericida, fungicida, esporicida y virucida. Este producto es biodegradable.",
    composicion: [
      { name: "Estado físico", valor: "Líquido" },
      { name: "Color", valor: "Blanco" },
      { name: "Olor", valor: "Tomillo" },
      { name: "pH", valor: "7.0 – 7.5" },
      { name: "Densidad", valor: "0.97 – 1.3 g/ml" },
    ],
  },
  {
    name: "Anillos Pall Ring",
    categorias: ["Tratamientos de agua y acueductos", "Agrícola"], // Agregado a tratamiento de aguas y agrícola
    slug: "anillos-pall-ring",
    portada: "/images/anillos-pall-ring.webp",
    descripcion:
      "Los anillos Pall Ring son lo más avanzado en las nuevas tecnologías para absorción de hierro en las torres de aireación de aguas provenientes de pozos profundos.",
    usos: "Los anillos Pall Ring son efectivos en la extracción de hierro. Son recuperables un 100%. Su lavado es simple y de bajo costo. Excelente flujo del líquido. Fácil de instalar en la torre de aireación. No infringen normas ambientales nacionales. Bajo peso. Excelente estabilidad mecánica.",
    composicion: [
      { name: "Dimensiones", valor: "2” de diámetro, 2” de alto" },
      { name: "Área de contacto", valor: "38 ft²/ft³" },
      { name: "Instalación", valor: "Simple y económica" },
      { name: "Peso por ft³", valor: "3.3 lb. /ft³" },
      { name: "Cantidad por m³", valor: "7.000 unidades" },
      { name: "Método de fabricación", valor: "Moldeado por Inyección" },
    ],
  },
  {
    name: "Anti-Incrustante",
    categorias: ["Tratamientos de agua y acueductos", "Agroquímicos"], // Agregado a tratamiento de aguas y agroquímica
    slug: "anti-incrustante",
    portada: "/images/anti-incrustante.webp",
    descripcion:
      "El anti-incrustante es un inhibidor de formación de incrustaciones y dispersante de alto rendimiento, desarrollado específicamente con moléculas muy específicas especializadas para ambientes incrustantes.",
    usos: "El anti-incrustante es efectivo en una amplia variedad de sales formadoras de incrustaciones (oxalato de calcio, carbonato de calcio, sulfato de calcio y limo). Excelente inhibición de carbonato de calcio, efectivo en sistemas con altos sólidos totales disueltos y alta alcalinidad/dureza. Excelente inhibición de sulfato de calcio, funciona en sistemas con aguas de alto y bajo pH.",
    composicion: [
      { name: "Apariencia", valor: "Líquido" },
      { name: "Color", valor: "Incoloro-amarillo" },
      { name: "pH", valor: "4.0 ± 0.5" },
      { name: "Densidad a 20°C", valor: "3.9 – 4.3 kg/gal" },
      { name: "Gravedad específica 20°C", valor: "1.090 ± 0.05" },
    ],
  },
  {
    name: "Antracita",
    categorias: ["Tratamientos de agua y acueductos", "Piscinas recreativas"], // Agregado a tratamiento de aguas y agrícola
    slug: "antracita",
    portada: "/images/antracita.webp",
    descripcion:
      "La antracita está constituida por partículas del mismo carbón, dura y durable, en varios tamaños y se encuentra visiblemente libre de arcilla, tierras extrañas, pizarra o materias orgánicas.",
    usos: "La antracita es utilizada principalmente en filtros para el tratamiento de agua.",
    composicion: [
      { name: "Gravedad específica", valor: "(g/cm³) 1,41" },
      { name: "Densidad aparente", valor: "(g/cm³) 0,75" },
      { name: "Humedad", valor: "(%) 3,62" },
      { name: "Coef. de uniformidad", valor: "(cu – d60) < 1,70" },
      { name: "Dureza (escala de Mohs)", valor: "3,5" },
    ],
  },
  {
    name: "Arena",
    categorias: ["Tratamientos de agua y acueductos", "Agrícola"], // Agregado a tratamiento de aguas y agrícola
    slug: "arena",
    portada: "/images/arena.webp",
    descripcion:
      "Las arenas son partículas de rocas y minerales muy finas formadas por la combinación de varios elementos metálicos con los elementos más comunes de la corteza terrestre: el oxígeno y el silicio. La arena se encuentra visiblemente libre de arcilla, polvo, materiales orgánicos y micáceos.",
    usos: "La arena es usada en las industrias de vidrio y como lecho filtrante en el tratamiento de agua.",
    composicion: [
      { name: "Gravedad específica", valor: "(g/cm³) 2.63" },
      { name: "Densidad aparente", valor: "(g/cm³) 1.76" },
      { name: "Humedad", valor: "(%) 0.02" },
      { name: "Coef. de uniformidad", valor: "(CU-D60) < 1.70" },
      { name: "Dureza (escala de Mohs)", valor: "7.00" },
    ],
  },
  {
    name: "Azufre",
    categorias: ["Petróleo", "Agroquímicos", "Curtiembres"], // Se asocian a varias categorías
    slug: "azufre",
    portada: "/images/azufre.webp",
    descripcion:
      "El azufre es un mineral nativo no metálico muy abundante en la naturaleza, polvo amarillo, insoluble en agua e insípido.",
    usos: "El azufre es utilizado en la producción de sulfuro de carbono, pulpa de madera, insecticidas, hule vulcanizado, fungicidas, detergentes, productos farmacéuticos y colorantes. Producción de ácido sulfúrico, manufactura de pasta de papel, vulcanización de caucho, colorante de productos químicos, drogas y productos farmacéuticos, fungicida, fertilizantes, revestimiento para fertilizantes de acción prolongada, pintura para franjas señalizadoras.",
    composicion: [
      { name: "Pureza", valor: "99.65%" },
      { name: "Humedad", valor: "0.30%" },
      { name: "Estado físico", valor: "Sólido" },
      { name: "Pasa malla", valor: "Malla 100" },
      { name: "Color", valor: "Amarillo claro" },
    ],
  },
  {
    name: "Bacterias",
    categorias: ["Tratamientos de agua y acueductos", "Agroquímicos", "Alimentos", "Curtiembres", "Farmacéutico", "Limpieza"],
    slug: "bacterias",
    portada: "/images/bacterias.webp",
    descripcion:
      "Las bacterias son un cultivo mixto de microorganismos eficientes benéficos naturales, sin manipulación genética, presentes en ecosistemas naturales, fisiológicamente compatibles unos con otros.",
    usos: "Las bacterias tienen muchos usos en áreas industriales y domésticos y su uso es de gran facilidad por no ser un producto peligroso. Reestablece el equilibrio microbiológico del suelo, mejorando sus condiciones físico – químicas, incrementa la producción de los cultivos y su protección, además conserva los recursos naturales, generando una agricultura y medio ambiente más sostenible.",
    composicion: [
      {
        name: "Microbiológica",
        valor: "Bacterias fototróficas, Bacterias ácido lácticas, Levaduras",
      },
      {
        name: "Toxicidad",
        valor: "No es irritante, ni tóxico. No es apto para consumo humano.",
      },
      {
        name: "Riesgo al fuego",
        valor: "No es inflamable ni es explosivo.",
      },
      { name: "pH", valor: "Menor o igual a 3.5" },
    ],
  },
  {
    name: "Bentonita Tipo A",
    categorias: ["Tratamientos de agua y acueductos", "Petróleo"],
    slug: "bentonita-tipo-a",
    portada: "/images/bentonita_tipo_a.webp",
    descripcion:
      "La bentonita tipo A es una arcilla de grano muy fino (coloidal) del tipo de montmorillonita que contiene bases y hierro. Se forma a partir de la descomposición de cenizas volcánicas y otros materiales a lo largo de millones de años.",
    usos: "La bentonita tipo A se comporta como agente reductor de la permeabilidad cuando está en contacto con el suelo de lagos y reservorios, mediante un efecto electrostático de sus moléculas que actúa como repelente del agua.",
    composicion: [
      { name: "Humedad a 105°C", valor: "<12%" },
      { name: "Hinchamiento", valor: ">23%" },
      { name: "pH", valor: "<10.5%" },
      { name: "Granulometría (+200 ASTM)", valor: ">80%" },
    ],
  },
  {
    name: "Bentonita Tipo B",
    categorias: ["Tratamientos de agua y acueductos", "Petróleo"],
    slug: "bentonita-tipo-b",
    portada: "/images/bentonita_tipo_b.webp",
    descripcion:
      "La bentonita tipo B es una arcilla de grano muy fino (coloidal) del tipo de montmorillonita que contiene bases y hierro. Se forma a partir de la descomposición de cenizas volcánicas y otros materiales a lo largo de millones de años.",
    usos: "La bentonita Tipo B es una bentonita de múltiples aplicaciones dentro del campo de la ingeniería civil, sostener las paredes de la perforación, sondeos verticales, cimentaciones especiales, convencionales (pilotes), mejora de suelos y la concentración del fluido depende de la conformación de terreno a perforar.",
    composicion: [
      { name: "Residuo mayor a 75um", valor: "<2.5%" },
      { name: "Viscosidad marsh 64g/L", valor: ">45 seg" },
      { name: "Filtrado (30 min)", valor: "<20 ml" },
    ],
  },
  {
    name: "Bentonita Tipo S",
    categorias: ["Tratamientos de agua y acueductos", "Petróleo"],
    slug: "bentonita-tipo-s",
    portada: "/images/bentonita_tipo_s.webp",
    descripcion:
      "La bentonita Tipo S es un aluminio silicato (arcilla) hidratada natural, su color varía de café claro, amarillo verdoso a casi café oscuro.",
    usos: "La bentonita Tipo S es utilizada principalmente en la metalurgia, agricultura, aglutinante y adsorbente.",
    composicion: [
      { name: "Silicio como SiO2", valor: "52.94%" },
      { name: "Hierro como Fe2", valor: "7.62%" },
      { name: "Aluminio como Al2O3", valor: "17.92%" },
      { name: "Calcio como CaO", valor: "1.48%" },
      { name: "Magnesio como MgO", valor: "2.50%" },
    ],
  },
  {
    name: "Benzoato de Sodio",
    categorias: ["Agroquímicos", "Alimentos", "Farmacéutico", "Curtiembres"],
    slug: "benzoato-de-sodio",
    portada: "/images/benzoato_de_sodio.webp",
    descripcion:
      "El benzoato de sodio es una sal del ácido benzoico de apariencia blanca, cristalina o granulada.",
    usos: "El benzoato de sodio es utilizado principalmente en la industria alimenticia, industria de bebidas, la industria química y farmacéutica. Inhibidor de la proliferación de microorganismos.",
    composicion: [
      { name: "Alcalinidad", valor: "Máx. 0.2 ml / gr" },
      { name: "Compuestos clorados", valor: "0.02% max" },
      { name: "Contenido, % en peso en base seca", valor: "99.0% min." },
      { name: "Metales pesados", valor: "0.001% máx." },
      { name: "Pérdidas por desecación a 105°C", valor: "0.3 % peso" },
    ],
  },
  {
    name: "Bicarbonato de Sodio",
    slug: "bicarbonato-de-sodio",
    portada: "/images/bicarbonato_de_sodio.webp",
    descripcion:
      "El bicarbonato de sodio es un compuesto sólido cristalino color blanco obtenido de un mineral presente en la naturaleza, este es soluble en agua.",
    usos: "El bicarbonato de sodio se usa principalmente como preservativo de alimentos, preservativo de cosméticos, enjuagues bucales y en diversos productos farmacéuticos. Usado como intermediario químico en la síntesis de colorantes, como inhibidor de corrosión y como antioxidante en líquidos anticongelantes. Agente conservador de acción inhibitoria del desarrollo de bacterias, hongos y levaduras, es un producto que tiene usos domésticos e industriales.",
    composicion: [
      { name: "Apariencia", valor: "Sólido blanco cristalino" },
      { name: "pH", valor: "8,3 (solución 0,1 M a 25ºC)" },
      { name: "P. Ebullición (°C)", valor: "Se descompone" },
      { name: "P. Fusión (°C)", valor: "50" },
      { name: "Peso molecular", valor: "84.01 g/mol" },
    ],
    categorias: ["Tratamientos de agua y acueductos", "Farmacéutico", "Limpieza", "Curtiembres", "Agroquímicos", "Piscinas recreativas"],
  },
  {
    name: "Bisulfito de Sodio",
    slug: "bisulfito-de-sodio",
    portada: "/images/bisulfito_de_sodio.webp",
    descripcion:
      "El bisulfito de sodio se trata de una sal ácida muy inestable que al reaccionar con el oxígeno se convierte en sulfato de sodio, soluble en agua. Se descompone por calentamiento intenso y en contacto con ácidos.",
    usos: "El bisulfito de sodio es un conservante alimentario y farmacéutico, agente de decloración de aguas residuales, reactivo de laboratorio, agente reductor, suplemento dietario y conservante de color. También utilizado en estudios de epigenética como método para el análisis de metilación, esto es, para determinar el patrón de metilación en el ADN.",
    composicion: [
      { name: "Pureza", valor: "99.0%" },
      { name: "Agua insoluble", valor: "0.03%" },
      { name: "Hierro", valor: "0.005%" },
      { name: "Metales pesados", valor: "<0.0005%" },
      { name: "Arsenico", valor: "<0.0002%" },
    ],
    categorias: ["Tratamientos de agua y acueductos", "Farmacéutico", "Piscinas recreativas", "Petróleo", "Curtiembres"],
  },
  {
    name: "Borax Decahidratado",
    slug: "borax-decaidratado",
    portada: "/images/borax_decaidratado.webp",
    descripcion:
      "El bórax decahidratado es un polvo blanco y cristalino sin olor que se disuelve en el agua, si se deja reposar al aire libre, pierde lentamente su hidratación.",
    usos: "El bórax decahidratado funciona como fertilizante, fundente, inhibidor de la corrosión, producción de vidrios y esmaltes para porcelana, herbicida y estabilizante del suelo, se usa en el control de hongos en los cítricos, anticongelante, inhibidores de oxidación.",
    composicion: [
      { name: "Apariencia", valor: "Cristales blancos" },
      { name: "Olor", valor: "Sin olor característico" },
      { name: "Gravedad específica", valor: "1.73" },
      { name: "Solubilidad en agua", valor: "5.92%" },
      { name: "Punto de fusión", valor: "75°C" },
    ],
    categorias: ["Agroquímicos", "Petróleo", "Tratamientos de agua y acueductos", "Limpieza", "Farmacéutico", "Curtiembres"],
  },
  {
    name: "Cal Hidratada 70%",
    slug: "cal-hidratada-al-70",
    portada: "/images/cal_hidratada_70.webp",
    descripcion:
      "La cal hidratada 70% es un material natural que se obtiene por hidratación del óxido de calcio, un polvo cristalino seco e incoloro.",
    usos: "La cal hidratada 70% es usada en la industria de la construcción para la elaboración de mezclas de albañilería, morteros a base de cal, revoques o pañetes, pintura para blanqueo, masillas en acabado fino, pegado de bloques, pegado de ladrillos, fabricación de bloques, mezclas asfálticas, estabilización de suelos arcillosos.",
    composicion: [{ name: "Hidróxido de calcio", valor: "70% Ca(OH)2" }],
    categorias: ["Curtiembres", "Tratamientos de agua y acueductos", "Petróleo", "Limpieza", "Agroquímicos"],
  },
  {
    name: "Cal Hidratada 90%",
    slug: "cal-hidratada-al-90",
    portada: "/images/cal_hidratada_al_90.webp",
    descripcion:
      "La cal hidratada 90% es obtenida en la calcinación de la caliza, reacciona inmediatamente con el agua, transformándose en hidróxido de calcio (Ca(OH)2).",
    usos: "La cal hidratada 90% es usada en curtiembres, tratamiento de aguas y refinación de azúcar, en sectores como la industria química, acuícolas, alimenticia, petrolera, rellenos sanitarios y minería.",
    composicion: [
      { name: "Hidróxido de calcio", valor: "Ca(OH)2 90% min." },
      { name: "Óxido de magnesio", valor: "MgO 1.0% Max." },
      { name: "Sílice", valor: "SiO2 1.0% Max." },
      { name: "Óxido de hierro - aluminio", valor: "Fe2O3+Al2O3 0.5% Max." },
      { name: "Insolubles", valor: "HCl 1.5% +/- 0.5 Max." },
    ],
    categorias: ["Curtiembres", "Petróleo", "Tratamientos de agua y acueductos", "Limpieza", "Agroquímicos"],
  },
  {
    name: "Cal Hidratada Tipo N",
    slug: "cal-hidratada-tipo-n",
    portada: "/images/cal_hidratada_tipo_n.webp",
    descripcion:
      "La cal hidratada tipo N es un hidróxido de calcio Ca(OH)2 que se elabora calcinando e hidratando mármol calcítico, bajo un estricto control de calidad para garantizar el cumplimiento de la norma “N” de la American Society for Testing and Materials (ASTM).",
    usos: "La cal hidratada tipo N es utilizada en la estabilización de suelos, limpieza de cueros, digestión de la pulpa en la industria del papel, desinfectante y acelerante para la descomposición de materia orgánica y evitar la proliferación de malos olores. Se usa en la neutralización de ácido para el control ambiental y en diferentes procesos de industria.",
    composicion: [
      { name: "CaO Total", valor: "Min. 70%" },
      { name: "Ca (OH)2 aprovechable", valor: "90 – 96% (Pureza)" },
      { name: "MgO Total", valor: "Max. 1%" },
      { name: "Hidróxidos totales", valor: "Min. 92%" },
      { name: "Residuos insolubles", valor: "Max. 1.75%" },
    ],
    categorias: ["Tratamientos de agua y acueductos", "Curtiembres", "Petróleo", "Limpieza", "Agroquímicos"],
  },
  {
    name: "Cal Hidratada Tipo E",
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Limpieza", "Curtiembres","Agroquímicos"], // Categoría principal "Químicos" y también en "Acueductos" debido a su uso en tratamiento de aguas
    slug: "cal-hidratada-tipo-e",
    portada: "/images/cal_hidratada_tipo_e.webp",
    descripcion:
      "La cal hidratada tipo E es un hidróxido de calcio Ca(OH)2 de alta pureza, bajo contenido de insolubles, muy fino y blanco. Se elabora bajo vigilancia directa del departamento técnico bajo un estricto control de calidad para cumplir con normas técnicas internacionales.",
    usos: "La cal hidratada tipo E es utilizada en la industria alimentaria para la producción de fosfatos de calcio y purificación de panela y azúcares, en la industria petroquímica se utiliza en la refinación de emulsión de aceites y en la elaboración de grasas lubricantes, también tiene amplios usos en el tratamiento de aguas en plantas industriales, acueductos y aguas residuales, se emplea en el cubrimiento de cables eléctricos.",
    composicion: [
      { name: "CaO Total", valor: "Min. 73.0%" },
      { name: "Ca (OH)2 aprovechable", valor: "Min. 95.0 % (Pureza)" },
      { name: "MgO Total", valor: "Max. 1.0%" },
      { name: "Residuos insolubles", valor: "Max. 0.5%" },
      { name: "SiO2", valor: "Max. 0.5%" },
    ],
  },
  {
    name: "Cal Viva Alta Pureza al 90%",
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Limpieza", "Curtiembres", "Agroquímicos"],
    slug: "cal-viva-alta-pureza-al-90",
    portada: "/images/cal_viva_alta_pureza_90.webp",
    descripcion:
      "La cal viva alta pureza es un producto muy higroscópico con un característico color blanco muy saturado, es un óxido de calcio de alta pureza.",
    usos: "La cal viva mejora la eficiencia en procesos con lechada de cal, especialmente en dosificaciones volumétricas y sistemas controlados de apagado de cal. También es utilizada en ingenios azucareros, procesos químicos especializados, tratamiento de efluentes, potabilización de agua y termoeléctricas.",
    composicion: [
      { name: "Óxido de calcio (total)", valor: "CaO total 90% min." },
      {
        name: "Óxido de calcio (disponible)",
        valor: "CaO disponible 87% min.",
      },
      { name: "Óxido de magnesio", valor: "MgO 1.5% Max." },
      { name: "Sílice", valor: "SiO2 1.5% Max." },
      { name: "Óxido de hierro + aluminio", valor: "Fe2O3+Al2O3 0.5% Max." },
    ],
  },
  {
    name: "Carbón Activado",
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Limpieza", "Curtiembres", "Agroquímicos", "Piscinas recreativas"], // Usos en tratamiento de agua, por lo que entra en "Acueductos" también
    slug: "carbon-activado",
    portada: "/images/carbon_activado.webp",
    descripcion:
      "El carbón activado es una esponja microscópica formada por micro cristales de carbón que posee una relación específica de micro y macro poros cuidadosamente diseñados, en función de la utilización del producto.",
    usos: "El carbón activado garantiza la durabilidad del material en operaciones en donde se requiere retro lavados en forma continua como la purificación y tratamiento de aguas. El carbón activado también se usa en el procesamiento de efluentes industriales, protección de resinas de intercambio iónico, entre otras. Este producto puede venir en diferentes granulometrías y grado alimenticio o industrial.",
    composicion: [
      { name: "Tamaño de partícula", valor: "8x30" },
      { name: "Densidad aparente (ASTM 2854)", valor: "0.45 – 0.50 g/cc" },
      { name: "Área superficial específica (N2 BET Method)", valor: "920" },
      { name: "Número de Yodo (JIS)", valor: "920" },
      { name: "Cenizas (ASTM 2866)", valor: "2.70" },
    ],
  },
  {
    name: "Carbón Coque",
    categorias: ["Petróleo","Tratamientos de agua y acueductos"],
    slug: "carbon-coque",
    portada: "/images/carbon_coque.webp",
    descripcion:
      "El carbón coque es un combustible sólido formado por la destilación de carbón bituminoso calentado a temperaturas de 500 a 1100 °C sin contacto con el aire. El proceso de destilación implica que el carbón se limpia de alquitrán, gases y agua.",
    usos: "El carbón coque es utilizado en grandes cantidades en altos hornos para la elaboración de hierro y en el tratamiento de agua, como agente reductor de diferentes partículas, olores, sabores en el agua; así como también óxidos metálicos.",
    composicion: [
      { name: "Alta Adsorción", valor: "-" },
      { name: "Eliminación parcial de olor", valor: "-" },
      { name: "Eliminación parcial de color", valor: "-" },
      { name: "Captación de partículas en los lechos de carbón", valor: "-" },
    ],
  },
  {
    name: "Carbón activado cascara de coco",
    categorias: ["Tratamientos de agua y acueductos", "Limpieza", "Farmacéutico"], // Específicamente utilizado en el tratamiento de agua
    slug: "carbon-activado-cascara-de-coco",
    portada: "/images/productos.webp",
    descripcion:
      "El carbón activado derivado de la cáscara de coco es muy eficiente para la purificación de agua, removiendo impurezas, y también es utilizado en la industria alimentaria y farmacéutica.",
    usos: "Se usa ampliamente en procesos de purificación de agua y aire, tratamiento de aguas residuales, y en la industria alimentaria y farmacéutica para adsorción de productos no deseados.",
    composicion: [
      { name: "Tamaño de partícula", valor: "8x30" },
      { name: "Densidad aparente", valor: "0.45 g/cc" },
    ],
  },
  {
    name: "Carbonato de Calcio",
    categorias: ["Químicos"],
    slug: "carbonato-de-calcio",
    portada: "/images/carbonato_de_calcio.webp",
    descripcion:
      "El carbonato de calcio es un compuesto químico, de fórmula CaCO3. Se trata de un compuesto ternario, que entra en la categoría de las oxosales.",
    usos: "El carbonato de calcio se usa principalmente en la manufactura de pintura, caucho, plástico, adhesivos, papel, dentífricos. Sirve como complemento del cemento, cerámicas, cosméticos, pesticidas, insecticidas, antibióticos, agente neutralizante y aditivo para alimentos.",
    composicion: [
      { name: "Gravedad específica (Agua=1)", valor: "2.7 - 2.95 / 20°C" },
      { name: "Punto de ebullición (ºC)", valor: "N.A." },
      { name: "Punto de fusión (ºC)", valor: "Descompone 825" },
      { name: "Densidad relativa del vapor (Aire=1)", valor: "N.A." },
      { name: "pH", valor: "8 - 9 (Solución acuosa)" },
    ],
  },
  {
    name: "Cinta Tornasol",
    slug: "cinta-tornasol",
    portada: "/images/cinta_tornasol.webp",
    descripcion:
      "La cinta tornasol es un papel tornasol indicador que cambia su color cuando una solución cambia de básica a acida o de acida a básica.",
    usos: "Las cintas tornasol son utilizadas como guía general para determinar el pH presente en una solución. Son comúnmente usadas para la medición del pH en el agua.",
    composicion: [
      /* {
        name: "Material",
        valor: "Mezcla de tintes naturales extraídos de líquenes",
      }, */
    ],
    categorias: ["Laboratorio", "Químicos Industriales", "Tratamientos de agua y acueductos", "Petróleo", "Farmacéutico"],
  },
  {
    name: "Cloro al 91% (Ácido Tricloroisocianúrico)",
    slug: "cloro-91-acido-tricloroisocianurico",
    portada: "/images/cloro_91.webp",
    descripcion:
      "El cloro al 91% es un desinfectante orgánico estabilizado de acción prolongada con una concentración del 91% de cloro activo. Posee baja absorción de humedad y se disuelve completamente a la rapidez adecuada, contribuyendo a un menor costo de tratamiento de agua.",
    usos: "Utilizado como agente desinfectante en plantas de tratamiento de agua residual y, en algunos casos, en agua potable. También se emplea en estanques, reservorios y piscinas.",
    composicion: [
      { name: "Peso molecular", valor: "232" },
      { name: "Cloro disponible", valor: "90.0% mínimo" },
      { name: "Ácido tricloroisocianúrico", valor: "99.0% mínimo" },
      { name: "Ácido cianúrico", valor: "55.5%" },
      { name: "Punto de fusión (con descomposición)", valor: "225 °C" },
    ],
    categorias: ["Tratamientos de agua y acueductos", "Piscinas recreativas", "Petróleo", "Farmacéuticos", "Curtiembres", "Agroquímicos"],
  },
  {
    name: "Cloruro de Amonio",
    slug: "cloruro-de-amonio",
    portada: "/images/cloruro_amonio.webp",
    descripcion:
      "El cloruro de amonio es una sal cristalina blanca, inolora, altamente soluble en agua y ligeramente soluble en alcohol. Su gravedad específica es de 1.527. Es un producto con sabor amargo y múltiples aplicaciones.",
    usos: "Utilizado como medicamento en ciertos casos, aunque su principal uso es en trabajos de metales como fundente y decapante. También se emplea para limpiar metales antes de soldar, en la fabricación de pilas secas, teñido de tejidos, lavado de pieles, generación de platinas en el bronce, alimentación animal, tratamiento de aguas, aditivo alimentario y como abono.",
    composicion: [
      { name: "NH4Cl", valor: "99.5% mínimo" },
      { name: "SO4", valor: "0.02% máximo" },
      { name: "Residuos de Ignición", valor: "0.4% máximo" },
      { name: "Hierro", valor: "0.0007% máximo" },
      { name: "Plomo", valor: "0.0005% máximo" },
    ],
    categorias: ["Petróleo", "Farmacéutico", "Agroquímicos", "Curtiembres"],
  },
  {
    name: "Cloruro Férrico Anhidro",
    slug: "cloruro-ferrico-anhidro",
    portada: "/images/cloruro_ferrico_anhidro.webp",
    descripcion:
      "El cloruro férrico anhidro es un compuesto químico del grupo de los haluros metálicos. Los cristales pueden tener un color verde oscuro al reflejar la luz y un color rojo purpúreo cuando la luz los atraviesa.",
    usos: "El cloruro férrico anhidro es utilizado como floculante-coagulante, solo o combinado con otros productos químicos. Su habilidad para coagular en un amplio rango de pH lo hace muy útil, siendo más eficiente que otros productos como el alumbre. También se emplea en artes gráficas, grabado de metales, lavado de planchas y en el coloreado de metales.",
    composicion: [
      { name: "Acidez (HCl)", valor: "0.1% aproximadamente" },
      { name: "FeCl2", valor: "0.3% máximo" },
      { name: "FeCl3", valor: "98.0% mínimo" },
      { name: "Insolubles", valor: "0.5% máximo" },
      { name: "Estado", valor: "Sólido" },
    ],
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Farmacéutico", "Agroquímicos"],
  },
  {
    name: "Cloruro Férrico Solución",
    slug: "cloruro-ferrico-solucion",
    portada: "/images/cloruro_ferrico_solucion.webp",
    descripcion:
      "El cloruro férrico solución es una solución acuosa de color rojizo oscuro, obtenida por cloración del cloruro ferroso. Corroe rápidamente la mayoría de los metales, excepto el titanio. Se debe evitar el contacto con objetos de aluminio, acero al carbón, acero inoxidable, cobre o nylon.",
    usos: "Se utiliza en plantas de tratamiento de aguas residuales y agua potable como un excelente floculante, especialmente en la remoción de orgánicos y arsénico. También se usa como agente de grabado en litografías y fotografía, catalizador, mordiente, agente oxidante-desinfectante, pigmento y aditivo de piensos.",
    composicion: [
      { name: "Cloruro férrico (FeCl3)", valor: "42.5% p/p" },
      { name: "Cloruro ferroso (FeCl2)", valor: "<0.2% p/p" },
      { name: "Hierro total (Fe)", valor: "14.7% p/p" },
      { name: "Acidez (HCl)", valor: "<0.3% p/p" },
      { name: "Insolubles", valor: "<0.1% p/p" },
    ],
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Farmacéutico", "Agroquímicos"],
  },
  {
    name: "Comparador de pH",
    slug: "comparador-de-ph",
    portada: "/images/comparador_de_ph.webp",
    descripcion:
      "El comparador de pH es un equipo básico para la medición de Cloro, pH y Bromo. Es utilizado principalmente en piscinas, plantas de tratamiento y pruebas rápidas en campo.",
    usos: "El comparador de pH es especial para piscinas, plantas de tratamiento y pruebas rápidas en campo.",
    composicion:
      [/* "El estuche del Kit Comparador de Cloro y pH incluye los tres o dos reactivos, dependiendo de la referencia del Kit." */],
    categorias: [
      "Laboratorio",
      "Instrumentos de Medición",
      "Piscinas recreativas", "Tratamientos de agua y acueductos"
    ],
  },
  {
    name: "EDTA",
    slug: "edta",
    portada: "/images/edta.webp",
    descripcion:
      "El EDTA (ácido etilendiaminotetraacético) es una sal blanca de etilendiamino tetraacético tetra sodio, utilizada como agente quelante de metales.",
    usos: "El EDTA es utilizado en el tratamiento de aguas residuales, de riego y de recuperación secundaria. También se usa como agente quelante en la preparación de jabones y detergentes cuando hay presencia de aguas duras.",
    composicion: [
      { name: "Solubilidad", valor: "Solubilidad en agua" },
      { name: "Partículas en suspensión", valor: "Libre de partículas" },
      { name: "Viscosidad al 10%", valor: "5 – 25" },
      { name: "Gravedad específica al 10%", valor: "1.05 – 1.07" },
      { name: "pH", valor: "10 – 13" },
    ],
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Agroquímicos", "Curtiembres", "Farmacéutico"],
  },
  {
    name: "Formol",
    descripcion:
      "El formol es una sustancia sumamente activa, su comportamiento es ácido. El formol al 37%, formaldehido o metanal, es el aldehído de constitución química más elemental y menor peso molecular. La solución del formaldehido al 37% en agua se estabiliza con metanol. Se presenta como líquido claro de olor fuerte picante.",
    slug: "formol",
    portada: "/images/formol.webp",
    usos: "El formol se usa como materia prima básica para la producción de resinas ureicas, melamínicas, fenólicas simples y modificadas, usadas en la industria textil, papelera, de maderas, pinturas, adhesivos, etc. También se emplea como bactericida y desinfectante en aplicaciones agrícolas y agropecuarias, elaboración de lacas, gomas, plásticos, cerveza y tintas.",
    composicion: {
      Concentracion: "37% +/- 1.0 / 44% +/- 1.0",
      Acidez: "0.03% MAX",
      Color: "APHA 5 MAX",
      Hierro: "1 PPM MAX",
      MetanolLibre: "7% MAX",
    },
    categorias: ["Agroquímicos", "Farmacéutico", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres"],
  },
  {
    name: "Fosfato Bicalcico",
    descripcion:
      "El fosfato bicalcico es un producto fabricado como resultado de la reacción directa del ácido fosfórico con el carbonato cálcico.",
    slug: "fosfato-bicalcico",
    portada: "/images/fosfato_bicalcico.webp",
    usos: "El fosfato bicalcico es un producto utilizado como materia mineral para la alimentación animal.",
    composicion: {
      FosforoP: "18%",
      SolubilidadCitrica: ">90%",
      CalcioCa: "23%",
      HumedadH2O: "<4%",
    },
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Agroquímicos", "Curtiembres", "Farmacéutico"],
  },
  {
    name: "Fosfato Diamonico",
    descripcion:
      "El fosfato diamonico (DAP) es un fertilizante fosfatado, una de las sales del fosfato de amonio solubles en agua, producido a partir de la reacción y neutralización entre el ácido fosfórico y el amoniaco.",
    slug: "fosfato-diamonico",
    portada: "/images/fosfato_diamonico.webp",
    usos: "El fosfato diamonico es un fertilizante superconcentrado apropiado como fuente fosfatada y nitrogenada. Se utiliza en suelos bien abastecidos con potasio y es eficaz para una amplia gama de cultivos, especialmente para arroz-riego.",
    composicion: {
      NitrogenoTotal: "18.0%",
      NitrogenoAmoniacal: "18.0%",
      FosforoAsimilable: "46.0%",
      HumedadMaxima: "1.5%",
    },
    categorias: ["Agroquímicos", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres", "Farmacéutico"],
  },
  {
    name: "Fosfato Trisodico",
    descripcion:
      "El fosfato trisódico es un sólido cristalino blanco e inoloro, altamente soluble en agua, produciendo una solución alcalina.",
    slug: "fosfato-trisodico",
    portada: "/images/fosfato_trisodico.webp",
    usos: "El fosfato trisódico se utiliza como ablandador de agua, en el tratamiento de agua en calderas, limpiador industrial, fabricación de papel, removedor de pinturas, emulsionante, detergentes y revelado fotográfico.",
    composicion: {
      FosforoP2O5: "18.00% min",
      HierroFe2O3: "0.08% máx",
      Humedad: "0.54% máx",
      Olor: "Inoloro",
      PerdidaPorCalcinacion: "56.90%",
    },
    categorias: ["Tratamientos de agua y acueductos", "Agroquímicos", "Petróleo", "Curtiembres", "Farmacéutico"],
  },
  {
    name: "Grava",
    descripcion:
      "La grava son partículas rocosas de tamaño variable, inertes, sin causar reacciones secundarias perjudiciales. Grava sílice lavada, secada y clasificada según granulometría definida.",
    slug: "grava",
    portada: "/images/grava.webp",
    usos: "La grava permite múltiples posibilidades de uso en la industria de la construcción, epoxi para pisos industriales y microfundición.",
    composicion: {
      GravedadEspecifica: "2.63 g/cm³",
      DensidadAparente: "1.76 g/cm³",
      Humedad: "0.02%",
      CoeficienteUniformidadCU: "< 1.70",
      Dureza: "7.00 (Escala de MOH)",
    },
    categorias: ["Tratamientos de agua y acueductos", "Petróleo", "Limpieza", "Curtiembres", "Agroquímicos", "Piscinas recreativas"],
  },
  {
    name: "Hidroxicloruro de Aluminio",
    descripcion:
      "El hidroxicloruro de aluminio es el resultado de un proceso de fabricación complejo bajo condiciones de trabajo controladas. Líquido inorgánico a base de sales de aluminio polimerizadas.",
    slug: "hidroxicloruro-de-aluminio",
    portada: "/images/hidroxicloruro_de_aluminio.webp",
    usos: "El hidroxicloruro de aluminio es usado como coagulante – floculante en el tratamiento de aguas industriales, municipales y residuales. También son ampliamente usados en la industria del papel como agentes de retención y para encolado en la fabricación de papel. En la clarificación de agua como coagulante primario y como ayudante de filtración.",
    composicion: {
      "Aluminio (Al2o3)": "20.0%",
      Basicidad: "72.0%",
      Densidad: "1.34 g/mL",
      Turbiedad: "17 NTU",
    },
    categorias: ["Agroquímicos", "Tratamientos de agua y acueductos", "Limpieza", "Petróleo", "Curtiembres", "Piscinas recreativas"],
  },
  {
    name: "Hipoclorito de Calcio al 70%",
    descripcion:
      'El hipoclorito de calcio 70% también llamado "cal clorada" es un compuesto químico cuya fórmula es Ca(ClO)2. Su apariencia es granulosa, de color beige claro. En solución acuosa desprende un olor similar al del hipoclorito sódico.',
    slug: "hipoclorito-de-calcio-70",
    portada: "/images/hipoclorito_de_calcio_70.webp",
    usos: "El hipoclorito de calcio al 70% es ampliamente utilizado en tratamiento de aguas por su alta eficacia contra bacterias, algas, moho, hongos y microorganismos peligrosos para la salud humana. Se utiliza como agente desinfectante del agua de las piscinas, principalmente en concentraciones del 70%.",
    composicion: {
      "Effective chlorine Content": "> 68%",
      Humidity: "8%",
      "Granularity (14-50 mesh)": "95.5%",
      "Appearance descripcion": "White solid granular",
      "Appearance sln": "Foggy",
    },
    categorias: ["Limpieza", "Piscinas recreativas", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres", "Agroquímicos"],
  },
  {
    slug: "hipoclorito-de-calcio-hth-americano",
    portada: "/images/hipoclorito_de_calcio_hth_americano.webp",
    name: "Hipoclorito de Calcio Hth Americano",
    descripcion:
      'El hipoclorito de calcio HTH es de origen Americano, también llamado "cal clorada" es un compuesto químico cuya fórmula es Ca(ClO)2. Su apariencia es granulosa, de color beige claro. En solución acuosa desprende un olor similar al del hipoclorito sódico. El peso molecular del hipoclorito de calcio es de 142.98 g/mol.',
    usos: "El hipoclorito de calcio HTH se utiliza para controlar algas y moho en los sistemas de enfriamiento de aguas tanto comerciales como industriales y recreacionales. Se usa ampliamente como un tratamiento de choque para destruir contaminación orgánica en las aguas de las piscinas y así mejora la claridad del agua.",
    composicion: {
      Olor: "Parecido al del cloro",
      "Contenido de cloro": "No más de 65%",
      Humedad: "No más de 5.5%",
      "Clorato Ion": "No más de 21.1 g/kg",
      "Bromo Ion": "No más de 121 mg/kg",
    },
    categorias: ["Piscinas recreativas", "Limpieza", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres", "Agroquímicos"],
  },
  {
    slug: "hipoclorito-de-sodio-al-5",
    portada: "/images/hipoclorito_de_sodio_5.webp",
    name: "Hipoclorito de Sodio al 5%",
    descripcion:
      "El hipoclorito de sodio al 5% es un agente químico perteneciente a la familia del cloro cuya característica más notable es su alto poder oxidante, transparentes, de color amarillo-verdoso y huele a cloro.",
    usos: "El hipoclorito de sodio al 5% es utilizado principalmente en el tratamiento de aguas, industria textil, agroindustria, industria de alimentos, cosmética, farmacéutica y hospitalaria: insumo de desinfección de superficies, materias primas, instrumental, equipos, áreas, etc.",
    composicion: {
      Apariencia: "Líquido traslucido color amarillo claro",
      Olor: "Característico a cloro",
      "Densidad (18°C)": "1.074 a 1.084 g/ml",
      pH: "12.0 mínimo",
      "Presión de vapor": "No disponible",
    },
    categorias: ["Limpieza", "Agroquímicos", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres", "Piscinas recreativas"],
  },
  {
    slug: "kit-de-derrame",
    portada: "/images/kit_de_derrame.webp",
    name: "Kit de derrame",
    descripcion:
      "El kit de derrames es un maletín que contiene implementos sencillos pero eficaces que incluyen todas las herramientas y materiales necesarios (Paños de tela oleofilicos, material absorbente, socks hidrofóbicas, monógafas de protección, guantes de nitrilo, recogedor, cinta de seguridad).",
    usos: "El kit de derrames cumple la labor de absorción, conteniendo, limpiando, eliminando de forma segura una variedad de derrames. El kit de derrames brinda tranquilidad y seguridad a los usuarios.",
    composicion: {
      "Material absorbente": "Incluido",
      "Monógafas de protección": "Incluidas",
      "Guantes de nitrilo": "Incluidos",
      Recogedor: "Incluido",
      "Cinta de seguridad": "Incluida",
    },
    categorias: ["Limpieza", "Farmacéutico"],
  },
  {
    name: "Lactosa",
    slug: "lactosa",
    portada: "/images/lactosa.webp",
    descripcion:
      "Azúcar natural formado por glucosa y galactosa; presente en la leche.",
    usos: [
      "Farmacéutico",
      "Alimentos infantiles",
      "Confitería",
      "Producción de penicilina, proteínas y riboflavina",
      "Margarina y mantequilla",
    ],
    composicion: {
      gravedadEspecifica: "1.525 (a 20ºC)",
      puntoEbullicion: "Se descompone",
      puntoFusion: "202°C",
    },
    categorias: ["Farmacéutico", "Alimentos", "Tratamientos de agua y acueductos", "Agroquímicos"],
  },
  {
    name: "Melaza",
    slug: "melaza",
    portada: "/images/melaza.webp",
    descripcion:
      "La melaza es un líquido viscoso de origen vegetal, de color marrón oscuro, procedente de la concentración de los caldos de producción de azúcar de caña de azúcar. De calidad alimentaria, sus propiedades como fertilizante son muy interesantes. La melaza es totalmente soluble en agua.",
    usos: [
      "La melaza es usada para la obtención de alcohol, como insumo para la elaboración de alimentos para ganado bovino, ingrediente alimenticio para pollos y cerdos.",
    ],
    composicion: {
      pH: 5.0,
      conductividadElectrica: "31.5 mS/cm",
      densidad: "1.4 kg/l",
      humedad: "26% (a 110ºC)",
      cenizas: "12.30% (Por calcinación a 550ºC)",
    },
    categorias: ["Agroquímicos", "Alimentos", "Petróleo", "Farmacéutico"],
  },
  {
    name: "Metasilicato de Sodio",
    slug: "metasilicato-de-sodio",
    portada: "/images/metasilicato_de_sodio.webp",
    descripcion:
      "Sustancia inorgánica, sólido blanco soluble en agua, formando una solución alcalina.",
    usos: [
      "Recuperación de papel",
      "Flotación de materiales",
      "Estabilizador en la industria textil",
      "Lavado de envases, metales y vidrios",
      "Formulación de detergentes sólidos",
      "Desengrasante industrial",
    ],
    composicion: {
      Na2O: "29.3%",
      SiO2: "28.4%",
      H2O: "41.6%",
      puntoFusion: "72.2°C",
    },
    categorias: ["Limpieza", "Tratamientos de agua y acueductos", "Petróleo"],
  },
  {
    name: "Nitrato de Potasio",
    slug: "nitrato-de-potasio",
    portada: "/images/nitrato_de_potasio.webp",
    descripcion:
      "Compuesto químico cristalino blanco, inodoro y soluble en agua.",
    usos: [
      "Neutralización de suelos ácidos",
      "Fertilización en riego por goteo y fertilización foliar",
      "Uso en flores, frutales, hortalizas y cultivos tradicionales",
    ],
    composicion: {
      nitrogenoTotal: "13%",
      nitrogenoAmoniacal: "0.8%",
      nitrogenoNitrico: "12.2%",
      fosforo: "3.0%",
      potasioSoluble: "44%",
    },
    categorias: ["Agroquímicos", "Petróleo", "Limpieza", "Curtiembres"], // Categorías asignadas
  },
  {
    name: "Ortotolidina",
    slug: "ortotolidina",
    portada: "/images/ortotolidina.webp",
    descripcion:
      "Reactivo químico, líquido incoloro a amarillo escaso, inestable al aire y luz.",
    usos: [
      "Determinación de cloro total en aguas residuales, industriales y potabilizadas",
      "Uso en piscinas y centros recreativos",
      "Aplicación en industrias farmacéuticas, alimenticias y cosméticas",
    ],
    composicion: {
      apariencia: "Líquido traslúcido",
      olor: "Ligeramente picante",
      color: "Incoloro",
      densidad: "1.015 g/cm³",
    },
    categorias: ["Tratamientos de agua y acueductos", "Farmacéutico", "Petróleo", "Agroquímicos", "Curtiembres"], // Categorías asignadas
  },
  {
    name: "Pastillas de Cloro al 91% (Ácido tricloroisocianúrico)",
    slug: "pastillas-de-cloro-al-91-acido-tricloroisocianurico",
    portada: "/images/pastillas_cloro_91.webp",
    descripcion:
      "Las pastillas de cloro son tabletas redondas de color blanco, tienen una concentración del 91% de cloro activo, con baja absorción de humedad y que se disuelve completamente a la rapidez adecuada, las características de las pastillas de cloro contribuyen a un menor costo de tratamiento de agua.",
    usos: "Las pastillas de cloro son un desinfectante orgánico estabilizado de acción prolongada, actúa como purificador permitiendo limpiar bacterias, algas, hongos, esporas y otros microorganismos. Se utilizan para el tratamiento de aguas de piscinas.",
    composicion: [
      { name: "Peso molecular", valor: "232" },
      { name: "Cloro disponible %", valor: "90,0 mínimo" },
      { name: "Ácido tricloroisocianurico %", valor: "99.0 mínimo" },
      { name: "Ácido cianurico %", valor: "55.5" },
      { name: "Solubilidad a 25 C (g/100 g Agua)", valor: "1.2" },
    ],
    categorias: ["Piscinas recreativas", "Limpieza", "Tratamientos de agua y acueductos", "Petróleo", "Agroquímicos"], // Categorías asignadas
  },
  {
    name: "Peróxido de Hidrogeno",
    slug: "peroxido-de-hidrogeno",
    portada: "/images/peroxido_hidrogeno_50.webp",
    descripcion:
      "El peróxido de hidrogeno al 50% es un líquido altamente polar, fuertemente enlazado con el hidrógeno, tal como el agua, por lo general de aspecto líquido ligeramente más viscoso. Es un oxidante potente y eficaz.",
    usos: "El peróxido de hidrogeno al 50% es utilizado principalmente como coadyuvante de tecnología en el proceso de blanqueo de vísceras del ganado bovino, caracú, tripa y gelatina, agente antimicrobiano en los procesos de producción de almidón, gelatina y papel y desinfectante para las industrias alimenticias, papel y celulosa, azúcar, y alcohol, textil, lavanderías y curtiembres.",
    composicion: [
      { name: "Peróxido de hidrogeno % p", valor: "50%" },
      { name: "Densidad a 25 °C, g/ml", valor: "1.203" },
      { name: "Oxígeno disponible %", valor: "50.9" },
      { name: "pH aparente", valor: "2.5" },
      { name: "Temperatura de almacenaje °C", valor: "-40 A +45 C" },
    ],
    categorias: ["Curtiembres", "Farmacéutico", "Tratamientos de agua y acueductos", "Petróleo", "Agroquímicos"], // Categorías asignadas
  },
  {
    name: "Plaguicida Agrocid",
    slug: "plaguicida-agrocid",
    portada: "/images/plaguicida_agrocid.webp",
    descripcion:
      "El plaguicida agrocid es un agente biológico de control de plagas, consiste en un extracto vegetal a base de ajo, ají, sábila y microorganismos fermentadores, que no generan resistencia por su composición natural.",
    usos: "Los componentes del agrocid repelen y controla potenciales insectos plaga en cultivos, a través de repelencia, efecto en el ciclo reproductivo e interferencia del sistema nervioso.",
    composicion: [
      { name: "Ajo", valor: "" },
      { name: "Ají", valor: "" },
      { name: "Sábila", valor: "" },
      { name: "Bacterias", valor: "" },
    ],
    categorias: ["Agroquímicos", "Tratamientos de agua y acueductos", "Petróleo"],
  },
  {
    name: "Policloruro de Aluminio Solido",
    slug: "policloruro-de-aluminio-solido",
    portada: "/images/policloro_aluminio_solido.webp",
    descripcion:
      "El policloruro de aluminio solido es un compuesto de polímero alto tipo inorgánico; la estructura molecular es tan larga y la capacidad de absorción es tan fuerte que la eficiencia de Purificación es mucho mejor que cualquier otro agente tradicional inorgánico de purificación de agua.",
    usos: "El policloruro de aluminio solido es utilizado como coagulante para clarificar aguas de consumo humano y tratar aguas residuales. Puede utilizarse como floculante en aguas de piscinas. Especial para aguas con alto contenido de hierro y metales pesados.",
    composicion: [
      { name: "Apariencia – olor", valor: "Polvo amarillento" },
      { name: "pH (solución al 1% w/v)", valor: "3.5 a 5.0" },
      { name: "Solubilidad en agua (g/L)", valor: "Soluble" },
      { name: "Punto de ebullición", valor: "No disponible" },
      { name: "Densidad", valor: "0.65 g/cm3" },
    ],
    categorias: ["Agroquímicos", "Piscinas recreativas", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres", "Farmacéutico"],
  },
  {
    name: "Policloruro de Aluminio Líquido",
    slug: "policloro-de-aluminio-liquido",
    portada: "/images/policloro_aluminio_liquido.webp",
    descripcion:
      "El policloruro de aluminio, abreviado generalmente como PAC, es el resultado de un proceso de fabricación complejo bajo condiciones de trabajo controladas. Líquido color Ámbar claro, obtenido por reacción del aluminio con Aluminio Metálico (latas).",
    usos: "El policloruro de aluminio liquido es usado como coagulante – floculante en el tratamiento de aguas industriales, municipales y residuales. También es ampliamente usado en la industria del papel como agente de retención y para encolado en la fabricación de papel.",
    composicion: [
      { name: "Aluminio (Al2O3)", valor: "20%" },
      { name: "Basicidad", valor: "72.0%" },
      { name: "Densidad", valor: "1.34 g/mL" },
      { name: "Turbiedad", valor: "17 NTU" },
    ],
    categorias: ["Agroquímicos", "Tratamientos de agua y acueductos", "Piscinas recreativas", "Petróleo", "Curtiembres", "Farmacéutico"],
  },
  {
    name: "Polímeros",
    slug: "polimeros",
    portada: "/images/polimeros.webp",
    descripcion:
      "Los polímeros son macromoléculas compuestas por una o varias unidades químicas (conocidas como monómeros). Se trata de un compuesto de cadena larga, formado por conjuntos funcionales unidos a conjuntos de carbonato. Se pueden conseguir en cargas Aniónicas, Catiónicas o no Iónicas.",
    usos: "Los polímeros son utilizados como floculante o ayudante de coagulación en una amplia variedad de aguas de consumo, municipal e industrial y aplicaciones en el tratamiento de aguas residuales. Ha sido aplicado con éxito en todos los sistemas de separación líquido/sólido incluyendo clarificación, espesamiento, deshidratación y filtración. Los polímeros pueden ser utilizado solo o en combinación con otros coagulantes orgánicos e inorgánicos.",
    composicion: [
      { name: "Apariencia", valor: "Polvo blanco granular" },
      { name: "Peso molecular", valor: "18 – 21" },
      { name: "ACM residual", valor: "250" },
      { name: "Contenido solido", valor: "88" },
    ],
    categorias: ["Agroquímicos", "Tratamientos de agua y acueductos", "Piscinas recreativas", "Petróleo", "Curtiembres"],
  },
  {
    name: "Potasa Caustica",
    slug: "potasa-caustica",
    portada: "/images/producto.webp",
    descripcion:
      "La potasa caustica es una sustancia química altamente alcalina, compuesto químico inorgánico e higroscópico que conforma una base fuerte de uso común.",
    usos: [
      "Elaboración de jabón",
      "Blanqueado",
      "Elaboración de sales de potasio",
      "Fuente de potasio para agro insumos",
      "Reactivo en química analítica",
      "Regeneración del caucho",
      "Refinación de hidrocarburos",
    ],
    composicion: [
      { name: "Fórmula Química", valor: "KOH" },
      { name: "Aspecto", valor: "Escamas de color Blanco" },
      { name: "Olor", valor: "Característico" },
      { name: "Concentración", valor: "Mínimo 90% de KOH" },
      { name: "Hierro", valor: "3% Max" },
    ],
    categorias: ["Agroquímicos", "Farmacéutico", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres"],
  },
  {
    name: "Reductor de pH para Piscinas",
    slug: "reductor-de-ph-piscinas",
    portada: "/images/producto.webp",
    descripcion:
      "El reductor de pH-piscinas es un producto líquido de apariencia ligeramente amarilla traslúcido, formado por ácido clorhídrico.",
    usos: [
      "Evita un pH demasiado alto, reduciendo el riesgo de irritación en ojos y piel",
      "Mejora la transparencia del agua",
      "Evita la disminución del poder desinfectante del cloro",
      "Disminuye el crecimiento de algas y bacterias",
      "Previene la precipitación de sales cálcicas",
    ],
    composicion: [
      { name: "Concentración, % mínimo", valor: "23" },
      { name: "Densidad, g/ml mínimo", valor: "1.23" },
    ],
    categorias: ["Piscinas recreativas", "Tratamientos de agua y acueductos", "Petróleo", "Agroquímicos", "Curtiembres", "Farmacéutico"],
  },
  {
    name: "Rojo Fenol",
    slug: "rojo-fenol",
    portada: "/images/producto.webp",
    descripcion:
      "El rojo fenol es un compuesto orgánico líquido cristalino de color rojo claro, utilizado como reactivo para la determinación colorimétrica de pH en el agua.",
    usos: [
      "Determinación de pH en aguas potabilizadas",
      "Tratamiento de aguas residuales",
      "Mantenimiento de piscinas",
      "Control del pH en aguas de proceso, crudas, etc.",
    ],
    composicion: [
      { name: "Apariencia", valor: "Líquido traslúcido color rojo brillante" },
      { name: "Olor", valor: "Ligeramente alcohólico" },
      { name: "Densidad (18 °C)", valor: "0.990 a 1.010 g/ml" },
      { name: "pH", valor: "7.5 a 7.7" },
      { name: "Solubilidad en agua", valor: "100% soluble" },
    ],
    categorias: ["Agroquímicos", "Tratamientos de agua y acueductos", "Piscinas recreativas", "Petróleo", "Curtiembres", "Farmacéutico"], // Relacionado con productos químicos y tratamiento de aguas
  },
  {
    name: "Round Up",
    slug: "round-up",
    portada: "/images/producto.webp",
    descripcion:
      "El Round Up es un herbicida sistemático no selectivo utilizado para el control de malezas anuales y perennes en áreas agrícolas, industriales y caminos.",
    usos: [
      "Control de malezas anuales y perennes en crecimiento activo, Absorción por hojas y tallos verdes, traslocándose hacia las raíces",
    ],
    composicion: [
      {
        name: "Glifosato",
        valor:
          "363 g/L de ácido glifosato de formulación a 20°C, equivalente a 446 g/L de sal potásica de N-(fosfonometil)-glicina.",
      },
    ],
    categorias: ["Agroquímicos", "Petróleo", "Limpieza", "Tratamientos de agua y acueductos"], // Relacionado con productos agroquímicos
  },
  {
    name: "Sal Hidrosal",
    slug: "sal-hidrosal",
    portada: "/images/producto.webp",
    descripcion:
      "La sal hidrosal (Cloruro de Sodio) es un sólido blanco cristalino, higroscópico y altamente soluble en agua, utilizado principalmente en el tratamiento de aguas.",
    usos: [
      "Regeneración de resinas de intercambio iónico",
      "Sistemas de esterilización",
      "Electrólisis y producción de salmuera para petróleos",
    ],
    composicion: [
      { name: "Cloruro de sodio", valor: "Min 99 % m/m base seca" },
      { name: "Magnesio", valor: "Max 2 Mg / kg" },
      { name: "Calcio", valor: "Max 12 Ca / kg" },
      { name: "Hierro total", valor: "Max 0.9 Fe / kg" },
      { name: "Humedad", valor: "Max 0.05 m/m de H2O" },
    ],
    categorias: ["Petróleo", "Agroquímicos", "Tratamientos de agua y acueductos", "Piscinas recreativas", "Curtiembres", "Farmacéutico"], // Utilizado en la industria del agua y el petróleo
  },
  {
    name: "Sal Industrial",
    slug: "sal-industrial",
    portada: "/images/producto.webp",
    descripcion:
      "El cloruro de sodio es una sustancia blanca y cristalina, completamente soluble en agua, extraída naturalmente y utilizada en una variedad de procesos industriales.",
    usos: [
      "Sazonar y conservar alimentos",
      "Aplicaciones industriales como la fabricación de productos químicos",
    ],
    composicion: [
      { name: "Estado físico", valor: "Sólido" },
      { name: "Apariencia y olor", valor: "Color blanco inodoro" },
      { name: "pH (50g/lt)", valor: "5-8" },
      { name: "Punto de fusión", valor: "800 °C" },
      { name: "Densidad a 20°C", valor: "1.35 gr/cm³" },
      { name: "Solubilidad en agua a 20°C", valor: "360 gr/l" },
    ],
    categorias: ["Agroquímicos", "Tratamientos de agua y acueductos", "Piscinas recreativas", "Petróleo", "Curtiembres", "Farmacéutico"], // Aplicaciones industriales y de laboratorio
  },
  {
    name: "Silicona Antiespumante",
    slug: "silicona-antiespumante",
    portada: "/images/producto.webp",
    descripcion:
      "La silicona antiespumante es una emulsión química, formulado con un fluido de polidimetilsiloxano y emulsionantes no iónicos, su viscosidad baja y su fácil dispersión aseguran su óptimo funcionamiento.",
    usos: [
      "La silicona antiespumante es muy útil en procesos industriales técnicos. Se recomienda como un rompedor de espuma en los sistemas acuosos alcalinos o agrios. La silicona antiespumante puede utilizarse en sistemas no acuosos puro o disperso en disolventes. También proporciona propiedades de antiespumante muy buenos en sistemas catiónico, aniónico.",
    ],
    composicion: [
      { name: "Apariencia", valor: "Líquido lechoso" },
      { name: "Densidad", valor: "1.01 ± 0.05" },
      { name: "pH", valor: "4.0 ± 1.0" },
      { name: "Solubilidad", valor: "Totalmente soluble en agua" },
    ],
    categorias: ["Tratamiento de agua y acueducto", "Agroquímicos", "Piscinas recreativas", "Petróleo", "Curtiembres", "Farmacéutico"], // Productos químicos y de laboratorio
  },
  {
    slug: "soda-caustica-en-escamas",
    name: "Soda Cáustica en Escamas",
    descripcion:
      "La soda caustica en escamas es un hidróxido cáustico usado en la industria (principalmente como una base química) en la fabricación de papel y el cartón. El hidróxido sódico se fabrica por electrólisis de una solución acuosa de cloruro sódico.",
    usos: "La soda cáustica en escamas es utilizada en la producción de papel, industrial textil, productos de petróleo, en la fabricación de aluminio, jabones y detergentes, rayón, celofán, sales de sodio, colorantes, y pigmentos, vidrio, productos farmacéuticos, cosméticos, así como también en la producción de otros productos para tratamiento de agua.",
    composicion: {
      NAOH: "98.00 min.",
      estado_fisico: "Sólido",
      color: "Blanco",
      olor: "Inoloro",
      peso_molecular: "40.00",
    },
    portada: "/images/producto.webp",
    categorias: [
      "Agroquímicos",
      "Alimentos",
      "Farmacéutico",
      "Tratamientos de agua y acueductos",
      "Petróleo", "Piscinas recreativas", "Curtiembres"
    ],
  },
  {
    slug: "soda-caustica-liquida",
    name: "Soda Cáustica Líquida",
    descripcion:
      "Soda Cáustica es el nombre comercial del Hidróxido de Sodio, así la Soda Cáustica 51% es una solución acuosa que contiene entre 48 y 51% en peso de NaOH aproximadamente.",
    usos: "La soda caustica liquida es utilizada en la producción de aceites jabones y detergentes, regeneración de resinas de intercambio iónico para tratamiento de agua, lavado de botellas de vidrio, blanqueo de celulosa en la industria de pulpa y papel. La soda caustica liquida también es utilizada en la producción de azúcar refinada, teñido de telas de algodón, producción de agroquímicos, fabricación de grenetinas y gelatinas, productos de limpieza en general, etc.",
    composicion: {
      odor: "Inoloro",
      hidroxido_de_sodio: "48% min.",
      carbonato_de_sodio: "0.10 – 0.20",
      oxido_de_sodio: "37.2 – 39.5",
      cloruro_de_sodio: "100ppm",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Farmacéutico", "Tratamientos de agua y acueductos", "Petróleo", "Piscinas recreativas", "Curtiembres"],
  },
  {
    slug: "sulfato-de-aluminio",
    name: "Sulfato de Aluminio",
    descripcion:
      "El sulfato de aluminio es un sulfato doble sal que tiene un metal univalente o radical tal como potasio, sodio, y un metal trivalente tal como aluminio, Ion férrico, cromo, cobalto, etc. El cual forma cristales definidos con 24 moléculas de agua.",
    usos: "El sulfato de aluminio es utilizado en la elaboración de caucho, tratamiento de aguas, industria química, empaque de carnes, industria del azúcar, industria del petróleo, entre otros.",
    composicion: {
      al2o3:
        "mínimo 15.2 % (Tipo B Granulado), mínimo 17.0% (Tipo A Granulado), mínimo 8.0 % (Tipo A Líquido), mínimo 7.3 % (Tipo B Líquido)",
      hierro_como_fe2o3:
        "máximo 2.0 % (Tipo B Granulado), máximo 0.75% (Tipo A Granulado), máximo 0.4 % (Tipo A Líquido), máximo 1.2 % (Tipo B Líquido)",
      materia_insoluble:
        "máximo 8.0% (Tipo B Granulado), máximo 0.50% (Tipo A Granulado), máximo 0.10 % (Tipo A Líquido), máximo 0.1 % (Tipo B Líquido)",
      basicidad:
        "mínimo 0.05% (Tipo B Granulado), mínimo 0.05 % (Tipo A Granulado), mínimo 0.5 % (Tipo A Líquido)",
      densidad:
        "1.31 – 1.34 g/ml (Tipo A y B Granulado), 1.31 - 1.34 g/ml (Tipo A y B Líquido)",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Piscinas recreativas", "Petróleo", "Farmacéutico", "Tratamientos de agua y acueductos", "Curtiembres"],
  },
  {
    slug: "sulfato-de-cobre",
    name: "Sulfato de Cobre",
    descripcion:
      "El sulfato de cobre es un solido cristalino, es la sal del ácido sulfúrico y del cobre, formada en el segundo grado de oxidación.",
    usos: "El sulfato de cobre se utiliza en tratamientos de agua como algicida en el mantenimiento de piscinas y áreas húmedas como baños, saunas, turcos y jacuzzis, como fungicida y fertilizantes compuestos (micro-elemento) en el sector agrícola, en la fabricación de alimentos concentrados para animales. Es utilizado en procesos de galvanotecnia del cobre, en mordientes textiles, industria del cuero, pigmentos, baterías eléctricas, recubrimientos de galvanizados, entre otros.",
    composicion: {
      pureza: "98.23 % min.",
      concentracion_cu: "25.00 % min.",
      humedad_a_270C: "36.02 % min.",
      ph_al_5: "3.50 % min.",
      plomo: "80.00 ppm máx.",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Piscinas recreativas", "Tratamientos de agua y acueductos", "Petróleo", "Curtiembres", "Farmacéutico"],
  },
  {
    slug: "sulfato-de-sodio-anhidro",
    name: "Sulfato de Sodio Anhidro",
    descripcion:
      "El sulfato de sodio anhidro es una sal inorgánica cristalina, blanca. Es obtenido de salmuera natural, altamente soluble en agua e inocuo para el medio ambiente.",
    usos: "El sulfato de sodio anhidro se utiliza en la industria de alimentos como vehículo para las esencias, detergentes como carga, farmacéutica como carga, galvanoplastia, limpieza, fabricación de papel kraft, cartulina, en el vidrio para eliminar las pequeñas burbujas que se puedan encontrar en el vidrio fundido, sales sódicas, vidriado cerámico. Es utilizado en el tratamiento de fibras textiles para reducir las cargas negativas sobre las fibras, permitiendo así que el colorante penetre más rápidamente sobre ellas.",
    composicion: {
      Na2SO4: "97.5% mín.",
      Humedad: "1.0% máx.",
      "Cloruros (NaCl)": "1000 ppm máx.",
      Hierro: "100 ppm máx.",
      "Insolubles en HCl": "0.05% máx.",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Farmacéutico", "Limpieza", "Agroquímicos"],
  },
  {
    slug: "sulfato-ferrico",
    name: "Sulfato Férrico",
    descripcion:
      "El sulfato férrico es una sal inorgánica en estado líquida de color rojizo, el cual es una sal oxidante fuerte capaz de disolver una amplia variedad de minerales sulfurados.",
    usos: "El Sulfato Férrico se usa para purificación de agua por floculación y para eliminar fosfatos en las plantas de depuración municipal e industrial para prevenir la eutrofización de masas de agua superficiales, además se tienen algunas aplicaciones en la medicina. Adicionalmente tiene usos en la industria del cuero.",
    composicion: {
      "Formula quimica": "Fe2(SO4)3(ac)",
      Densidad: "1.48 ± 0.04",
      "Contenido de hierro férrico": "8.5 ± 0.5%",
      "Contenido de hierro ferroso": "2.0% máx.",
      "Contenido de insolubles": "0.1% máx.",
    },
    portada: "/images/producto.webp",
    categorias: ["Tratamientos de agua y acueductos", "Farmacéutico", "Petróleo", "Curtiembres"],
  },
  {
    slug: "talco-chino",
    name: "Talco Chino",
    descripcion:
      "El talco chino es un talco laminar tipo estealita de partícula fina y alta pureza, con bajo contenido de hierro y libre de asbestos.",
    usos: "El talco chino es utilizado principalmente en pinturas arquitectónicas acuosas para interiores sanitados, mates y semibrillantes, pinturas arquitectónicas flexibles para exteriores, selladores para maderas, pinturas elastómeras y pinturas sobre madera para exteriores.",
    composicion: {
      "% whiteness Y": "88.0",
      "Contenido de humedad a 105°C": "0.50%",
      "Gravedad específica": "2.70",
      "% Absorción de aceite (g/100g)": "25.0 – 38.0",
      "Dureza (escala Mohs)": "1.00",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Farmacéutico", "Limpieza", "Petróleo", "Curtiembres"], // Asigné estas categorías debido a sus usos en pinturas, selladores y productos industriales
  },
  {
    slug: "tripolifosfato-de-sodio",
    name: "Tripolifosfato de Sodio",
    descripcion:
      "El tripolifosfato de sodio es un compuesto inorgánico específicamente una sal de sodio, se obtiene de la reacción del carbonato de sodio con el ácido fosfórico.",
    usos: "El tripolifosfato de sodio tiene aplicaciones en diferentes industrias: en la agricultura, en la industria de la construcción, en la fabricación de papel, fabricación de detergentes, textiles, pinturas, pigmentos, recubrimientos, artículos de vidrio, tratamiento de agua, acondicionamiento de lodos para perforación entre otros.",
    composicion: {
      Na5P3O10: "96.98%",
      P2O5: "57%",
      "PH Solución": "9.3 - 10.0",
      Monofosfato: "1%",
      Insoluble: "0.1%",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Farmacéutico", "Limpieza", "Curtiembres", ], // Por sus aplicaciones en limpieza, tratamientos de agua y sectores industriales
  },
  {
    slug: "urea",
    name: "Urea",
    descripcion:
      "La urea es un compuesto orgánico, soluble en agua, formado por carbón, nitrógeno, oxígeno e hidrógeno. Es un fertilizante nitrogenado de amplio uso.",
    usos: "Fertilizante simple granulado N para aplicación al suelo. Se puede incorporar al suelo previo a la siembra y al ser un fertilizante de reacción ácida, se puede utilizar en suelos neutros o ligeramente alcalinos. La urea es eficaz en cultivos de arroz, algodón, sorgo, maíz, caña, pastos, banano, café.",
    composicion: {
      "Nitrógeno Total (N)": "46.0%",
      "Nitrógeno Uréico (N)": "46.0%",
      Biuret: "máximo 1.5%",
      Humedad: "máxima 1.0%",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Curtiembres", "Tratamientos de agua y acueductos"], // Debido a su uso como fertilizante en agricultura y su relación con la industria agrícola y petrolera
  },
  {
    slug: "zeolita",
    name: "Zeolita",
    descripcion:
      "Es un mineral que pertenece a los aluminosilicatos cristalinos microporosos. Mezcla adecuada de clinoptilolita natural y otros componentes a base de aluminio.",
    usos: "Utilizada para la remoción alta de Hierro presente en aguas subterráneas, superficiales y de proceso. Actúa como un catalizador insoluble en la reacción entre el oxígeno disuelto y el hierro presente en el agua en forma de Fe+2 Fe+3, produciendo hidróxido férrico en forma de precipitado que favorece componentes del producto (actuando a la vez como filtro).",
    composicion: {
      SiO2: "35.3%",
      Al2O3: "16.7%",
      Ca2O: "2.78 ‐ 5.78%",
      Fe2O3: "1.07 ‐ 2.08%",
      Na2O: "1.34 ‐ 2.39%",
    },
    portada: "/images/producto.webp",
    categorias: ["Agroquímicos", "Petróleo", "Tratamientos de agua y acueductos", "Piscinas recreativas", "Curtiembres", "Farmacéutico"], // Aplicación en tratamiento de agua y filtrado de hierro, por lo que se asocia con la industria agrícola, de laboratorio y petrolera
  },
  {
    name: "Limpiavidrios",
    categorias: ["Limpieza"],
    slug: "limpiavidrios",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Producto líquido de color azul, libre de partículas en suspensión. Ideal para limpiar la suciedad común y acumulada de superficies de vidrio lavables.",
    usos: "Es ideal para disolver y limpiar la suciedad común y acumulada de las superficies de vidrio lavables entre ellas: residuos de grasa, polvo o humo. Puede ser usado en vidrios, espejos, baldosas, vitrinas, vidrios de carros, muebles mobiliarios o azulejos. Este producto es para uso institucional (hoteles, restaurantes, hospitales, instituciones educativas e instituciones en general).",
    composicion: [
      { name: "pH directo (25°C)", valor: "7.5 – 8.5" },
      { name: "Densidad aparente (25°C)", valor: "0.95 – 1.05 g/ml" },
    ],
  },
  {
    name: "Detergente Líquido",
    categorias: ["Limpieza", "Petróleo", "Farmacéutico"],
    slug: "detergente-liquido",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Líquido opaco viscoso para limpieza de prendas y superficies.",
    usos: "Es ideal para el lavado de prendas y superficies. Especialmente desarrollado para ser usado en lavanderías hoteleras, comerciales, industriales y hospitalarias. Es adecuado para todos los tejidos blancos y de color. Puede ser dosificado de forma manual o automática.",
    composicion: [
      { name: "pH Directo (25°C)", valor: "9,0 – 10,0" },
      { name: "Densidad g/mL (25°C)", valor: "0,95 – 1,05" },
    ],
  },
  {
    name: "Detergente Ácido de Uso Industrial",
    categorias: ["Limpieza", "Petróleo", "Farmacéutico"],
    slug: "detergente-acido-industrial",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Producto líquido traslúcido, utilizado para la limpieza de superficies metálicas y no metálicas.",
    usos: "Actúa como desoxidante, desincrustante y desmanchador de superficies metálicas y no metálicas. De uso en un amplio rango de aplicaciones en superficies y procesos CIP para la industria de alimentos, bebidas y otras industrias.",
    composicion: [
      { name: "Densidad, g/mL", valor: "1.10 – 1.20" },
      { name: "pH directo (Máx. 20°C)", valor: "0.0 – 1.0" },
    ],
  },
  {
    name: "Limpiador Desinfectante de Superficies Fresh",
    categorias: ["Limpieza", "Petróleo", "Agroquímicos", "Curtiembres", "Farmacéutico"],
    slug: "limpiador-desinfectante-fresh",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Producto líquido desinfectante para limpieza de superficies con aroma fresh.",
    usos: "Fue diseñado para uso comercial, institucional e industrial, en lugares como: hoteles, peluquerías, gimnasios, establecimientos comerciales, centros religiosos, restaurantes, oficinas, colegios e instituciones en general, que requieran limpiar, desinfectar y además brindar un agradable aroma en espacios y superficies.",
    composicion: [
      { name: "pH (directo), 25°C", valor: "4.0 – 5.0" },
      { name: "Densidad g/L (25°C)", valor: "0.95 – 1.05" },
    ],
  },
  {
    name: "Limpiador Desinfectante de Superficies Lavanda",
    categorias: ["Limpieza", "Petróleo", "Agroquímicos", "Curtiembres", "Farmacéutico"],
    slug: "limpiador-desinfectante-lavanda",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Producto líquido desinfectante para limpieza de superficies con aroma lavanda.",
    usos: "Fue diseñado para uso comercial, institucional e industrial, en lugares como: hoteles, peluquerías, gimnasios, establecimientos comerciales, centros religiosos, restaurantes, oficinas, colegios e instituciones en general, que requieran limpiar, desinfectar y además brindar un agradable aroma en espacios y superficies.",
    composicion: [
      { name: "pH (directo), 25°C", valor: "4.0 – 5.0" },
      { name: "Densidad g/L (25°C)", valor: "0.95 – 1.05" },
    ],
  },
  {
    name: "Lavaloza Líquido",
    categorias: ["Limpieza", "Petróleo", "Agroquímicos", "Curtiembres", "Farmacéutico"],
    slug: "lavaloza-liquido",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Producto líquido, con alto poder limpiador, desengrasante y eliminador de olores.",
    usos: "Es un producto diseñado para uso en hoteles, restaurantes, colegios e instituciones en general. Es efectivo en la remoción de todo tipo de grasas y eliminación de olores en recipientes y utensilios lavables. Para aplicación manual.",
    composicion: [
      { name: "pH directo (25°C)", valor: "8.5 – 9.5" },
      { name: "Densidad (18 a 23°C), g/mL", valor: "0.95 – 1.05" },
    ],
  },
  {
    name: "Alcohol Glicerinado",
    categorias: ["Limpieza", "Farmacéutico", "Alimentos"],
    slug: "alcohol-glicerinado",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion: "Alcohol glicerinado con Aloe Vera y agentes humectantes.",
    usos: "Es un producto desarrollado para limpiar y eliminar bacterias sin necesidad de agua ni jabón, para uso tópico y externo.",
    composicion: [
      { name: "pH directo a (25°C)", valor: "7.5 a 8.5" },
      { name: "Densidad aparente (25°C), g/ml", valor: "0.85–0.95" },
    ],
  },
  {
    name: "Gel Antibacterial",
    categorias: ["Limpieza", "Farmacéutico", "Petróleo", "Agroquímicos", "Curtiembres"],
    slug: "gel-antibacterial",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Gel antibacterial para la eliminación de bacterias de las manos y antebrazos.",
    usos: "Es un producto diseñado para la eliminación de bacterias de las manos del personal que labora en las diferentes áreas de las industrias procesadoras de alimentos y manufactureras, hospitales, restaurantes e instituciones en general.",
    composicion: [
      { name: "pH directo (25°C)", valor: "6.0 – 8.0" },
      { name: "Densidad aparente g/ml (25°C)", valor: "0.85-0.95" },
      { name: "Viscosidad Cps (25°C)", valor: "5000-7000" },
    ],
  },
  {
    name: "Jabón Cremoso para Manos y Cuerpo",
    categorias: ["Limpieza", "Cosméticos"],
    slug: "jabon-cremoso-manos-cuerpo",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Jabón cremoso para manos y cuerpo con extracto de almendras para humectar y proteger.",
    usos: "Es un producto cosmético para uso externo. Puede ser usado para el baño diario o como dispensador para el lavado frecuente de manos durante las actividades diarias, en la industria e instituciones en general.",
    composicion: [
      { name: "% Tensioactivo anionico", valor: "Mínimo 4.0" },
      { name: "pH directo a (25°C)", valor: "6.5 - 7.5" },
      { name: "Densidad aparente (25°C), g/ml", valor: "0.95-1.05" },
      { name: "Viscosidad (Cps)", valor: "4000-5000 Cps (25°C)" },
    ],
  },
  {
    name: "Detergente Multiusos Desengrasante",
    categorias: ["Limpieza", "Petróleo", "Agroquímicos", "Curtiembres", "Farmacéutico"],
    slug: "detergente-multiusos-desengrasante",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion: "Producto en polvo color blanco sin aroma.",
    usos: "Diseñado para uso industrial en cocinas (menajes y utensilios), pisos, paredes, restaurantes en general, lavanderías y demás instituciones. También puede ser usado en lavado a mano o en lavadora de prendas.",
    composicion: [
      { name: "Tensoactivo aniónico, %", valor: "Mín. 17.25" },
      { name: "pH (solución al 1%), 20 °C", valor: "10.0 ± 1" },
      { name: "Densidad aparente al empacar (g/L)", valor: "Mín. 340" },
      { name: "Humedad al empacar, %", valor: "Máximo 3.5" },
    ],
  },
  {
    name: "Detergente en Polvo Multiusos",
    categorias: ["Limpieza", "Petróleo", "Farmacéutico"],
    slug: "detergente-en-polvo-multiusos",
    portada: "/images/productos.webp", // Puedes reemplazar con la imagen adecuada para el producto
    descripcion:
      "Producto en polvo con aroma floral (Color azul) y sin aroma (Color blanco) para el lavado de prendas y superficies.",
    usos: "Es ideal para el lavado de prendas y superficies. Puede ser usado en lavanderías, hospitales, fábricas, hoteles, condominios, estaciones de servicio, restaurantes, comedores industriales, talleres mecánicos.",
    composicion: [
      { name: "Tensoactivo aniónico, %", valor: "Mínimo 5,00" },
      { name: "pH (solución al 1%), 20° C", valor: "10,0 ± 1" },
      { name: "Densidad aparente al empacar (g/L)", valor: "Mín. 360" },
      { name: "Humedad al empacar, %", valor: "Máximo 2,5" },
    ],
  },
  {
    name: "Hipoclorito de sodio al 15%",
    categorias: ["Tratamientos de agua y acueductos", "Agroquímicos", "Petróleo", "Limpieza", "Curtiembres"],
    slug: "hipoclorito-de-sodio-al--15",
    portada: "/images/productos.webp",
    descripcion:
      "El hipoclorito de sodio es un compuesto químico inorgánico que se obtiene saturando el cloro con una solución acuosa de hidróxido de sodio, fuertemente oxidante de fórmula NaClO. Contiene cloro en estado de oxidación +1.",
    usos:"El hipoclorito de sodio es el mejor desinfectante doméstico que se conoce, si es empleado racionalmente resulta de gran utilidad para preservar la salud, tanto de las personas, como de los animales.Su poder germicida es comprobado y por tanto es ampliamente utilizado en clínicas, hospitales, restaurantes y en los hogares, se vende en el mercado con diferentes nombres, pero todos esos productosestán basados en hipoclorito de sodio.",
    composicion: [
      { name: "Cloro disponible (C2)", valor: "15% min. Aprox" },
      { name: "Hipoclorito de sodio", valor: "155 g/l Aprox" },
      { name: "Soda (NaOH)", valor: "10% max. Aprox" },
      { name: "Densidad", valor: "1.220 g/cm. Aprox" },
      { name: "Hierro, ppm", valor: "0.5 ppm máximo" },
   
    ],
  },
  {
    name: "Hiposulfito de sodio",
    categorias: ["Petróleo", "Agroquímicos", "Farmacéutico", "Curtiembres"],
    slug: "hiposulfito-de-sodio",
    portada: "/images/productos.webp",
    descripcion:
      "El hiposulfito de sodio es un compuesto inorgánico cristalino que se encuentra con mayor frecuencia en forma de pentahidratado Na2S2O3·5H2O. Su estructura cristalina es de tipo monoclínica.",
    usos:"El hiposulfito de sodio es usado como agente reductor en estampado por descarga y decoloración de tejidos, blanqueo de azúcar, jabón, aceites, depurador de oxígeno para caucho sintético.",
      composicion: [
      { name: "Densidad", valor: "0.90 grs./mls" },
      { name: "Estabilidad inestable al aire, a la humedad y al calor" },
      { name: "Insoluble", valor: "Alcohol, disolventes" },
      { name: "Metales pesados", valor: "0.00%" },
      { name: "Na Cl", valor: "5+/-1%" },
   
    ],
  },{
    name: "Sulfato de Aluminio Granulado A y B ",
    categorias: ["Tratamientos de agua y acueductos", "Agroquímicos", "Piscinas recreativas", "Curtiembres", "Farmacéutico"],
    slug: "sulfato-de-aluminio-granulado-a-y-b",
    portada: "/images/productos.webp",
    descripcion:
      "El sulfato de aluminio es conocido comercialmente como “alumbre”. Por supuesto, no es un alumbre verdadero: por definición es un sulfato doble sal que tiene un metal univalente o radical tal como potasio, sodio, y un metal trivalente tal como aluminio, Ion férrico, cromo, cobalto, etc. El cual forma cristales definidos con 24 moléculas de agua.",
    usos:"El Sulfato de Aluminio granulado es usado en la coagulación, consiste en la desestabilización y agrupación de los sólidos en pequeñas masas o flocs, cuyo peso especifico es superior al del agua. Los dos pasos más importantes son: mezcla y floculación.",
    composicion: [
      { name: "Apariencia", valor: "Amarillo/Blanco" },
      { name: "Al2O3", valor: "Min % 17.00 min" },
      { name: "Hierro como", valor: "Fe2O3 0.75 máx" },
      { name: "Materia insoluble máx", valor: "0.50" },
      { name: "Al2O3 basicidad min. %", valor: "0.050" },
      { name: "% Alumina", valor: "Minimo 15.2 15.23" },
      { name: "%FE 203", valor: "Máximo 21.91" },
      { name: "% Insoluble", valor: "Máx 86.62" },
      { name: "PH (1%)", valor: "2.8 - 3.4 - 2.941" },
   
    ],
  }, {
    name: "Arena para Filtros",
    categorias: ["Tratamientos de agua y acueductos", "Piscinas recreativas"],
    slug: "arena-para-filtros",
    portada: "/images/productos.webp",
    descripcion:
      "La arena para filtros sílice lavada, secada y clasificada según granulometría definida, con condiciones de esfericidad que permite una adecuada porosidad y permeabilidad al fluido.",
    usos:"La arena es usada para fabricación de Baldosas, Campos deportivos, Resinas Epoxi para pisos industriales, Sandblasting , Jardines. También como medio filtrante en el tratamiento de aguas potables, residual o en filtros para piscinas.",
      composicion: [
      { name: "SiO2", valor: "99.86" },
      { name: "Na2O", valor: "0.01" },
      { name: "K2O", valor: "0.01" },
      { name: "Al2O3", valor: "0.16" },
      { name: "TiO2", valor: "0.04" },
      { name: "Fe2O3", valor: "0.09" },
      { name: "CaO", valor: "< 0,01" },
      { name: "MgO", valor: "< 0,10" },
      { name: "Perd. X Calc", valor: "0.15" },
   
    ],
  },{
    name: "Laboratorios",
    categorias: ["Laboratorio"],
    slug: "Laboratorios",
    portada: "/images/laboratorios.webp",
    descripcion:
      "",
    usos:"",
      composicion: [
      { name: "", valor: "" },
    ],
  },
];
